import { NashiMessendzhery } from './NashiMessendzhery';
import { mskDlyaPolya, mskIzPolya, mskVChas } from "../../../lib/vremyaMsk";
import { useEffect, useLayoutEffect, useRef, useState } from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { Link, useNavigate } from "react-router-dom";
import {
  IconArrowBackUp,
  IconArrowLeft,
  IconCalendarCheck,
  IconCalendarPlus,
  IconCheck,
  IconDotsVertical,
  IconFileDescription,
  IconPlayerPause,
  IconPlayerPlay,
  IconTrash,
  IconPhone,
  IconPhoneOff,
  IconUser,
  IconUserPlus,
  IconFile,
  IconChevronDown,
  IconLink,
  IconLinkOff,
  IconMicrophone,
  IconPaperclip,
  IconSend,
  IconX,
  IconExternalLink,
  IconCash,
} from "@tabler/icons-react";
import { cn } from "../../design-system/components";
import { useLabel, useText } from "../../clients/words";
import { MaskaTelefona } from "../../hodba/MaskaTelefona";
import {
  fetchRazbor,
  klyuchPodpisi,
  fetchHronikaObrashcheniya,
  drugoyMessendzher,
  etoKlientka,
  novayaKlientka,
  obedinit,
  otbrosit,
  otlozhit,
  otvetit,
  poiskKlientki,
  podgotovitShablon,
  poslatShablon,
  prilozhit,
  rasshifrovat,
  razedinit,
  razobrano,
  shablony,
  vernut,
  vernutIzOtlozhennyh,
  vzyat,
  type NaydennayaKlientka,
  type Razbor as RazborDannye,
  type ShablonStroka,
  type SoobshchenieLenty,
} from "../api";
import { useDiktovka } from "../diktovka";
import { klyuchNamereniya, snyatNamerenie, useChernovik } from "../chernoviki";
import { PolosaKudaUydyot } from "./KudaUydyot";
import { useVidimyyDialog } from "../../uvedomleniya/vidimyeDialogi";
import { PoleOtveta } from "./PoleOtveta";
import { useArenda } from "../../aktualnost/useArenda";
import { PolosaArendy } from "../../aktualnost/PolosaArendy";
import { razborKey, useHod, useZaderzhka } from "../hooks";
import { ZnachokKanala } from "./ZnachokKanala";
import { LentaHroniki } from "./LentaHroniki";
import { PodpisStroki, Puzyr, TekstShablona } from "./Puzyr";
import { lidVObzvon, neDozvonilas, peredatLid, putZapisiIzLida, zapisIzRazbora, type RazborLida } from "../../doski/api";
import { useZapisRyadom } from "../../zapis/zapisRyadomContext";
import { Peredat } from "../../doski/components/Dialogi";
import { useBezUs } from "../../auth/denX";

/**
 * РАСКРЫТАЯ СТРОКА — переписка, как в Telegram: шапка, пузыри, поле ответа.
 *
 * ⛔ ПОЛОСА «ОТВЕТ УЙДЁТ ОТ» СТОИТ ВСЕГДА И СРАЗУ ПОД ШАПКОЙ. Требование
 * владельца (1): дежурный ведёт три филиала с разными номерами и «должен чётко
 * понимать кому пишет и от кого читает». Номер не выбирается руками — он берётся
 * из канала, в который написали; выбор привёл бы к ответу клиентке клиники с
 * номера лэш-студии.
 */

interface Props {
  dannye: RazborDannye | undefined;
  gruzitsya: boolean;
  onNazad?: () => void;
  /**
   * Открыть ДРУГОЕ обращение — сегодня это «написать в другой мессенджер»
   * (`s606`, Ф4). Экран не переключает себя сам: какое обращение открыто, знает
   * страница, и второй источник этого знания разошёлся бы с адресом.
   */
  onOtkryt?: (id: number) => void;
  /**
   * `s635`: переписка ВНУТРИ карточки лида доски. Шапка с ходами и ряд
   * «этот диалог / вся хроника» не рисуются — ходы у карточки свои (§31.8), а
   * лента — одна на клиентку (`LentaHroniki`, `s619`). «Ответ уйдёт» и
   * «Шаблоны» встают над полем ответа, как на макете `s625`.
   */
  vstroen?: boolean;
  senderNearReply?: boolean;
  /**
   * `s681`: клиентка сбоку не помещается колонкой (телефон, узкий ноутбук) —
   * кнопка «Клиентка» в шапке открывает её; имя в шапке — та же кнопка.
   */
  onKlientka?: () => void;
  klientkaSlovo?: string;
  /**
   * `s681`: клиентка стоит колонкой рядом — «визитов» и «последний визит» живут
   * там; в шапке переписки их второй раз не пишем (одна величина — одно место, §31.8).
   */
  klientkaRyadom?: boolean;
  /**
   * `s681`: у экрана есть окно клиентки («Найти в базе», «Завести клиентку» по
   * номеру) — те же ходы в меню «⋮» не повторяем (одно действие — одно место, §31.8).
   * Лайт-чат окна клиентки не имеет — там пункты остаются.
   */
  klientkaVOkne?: boolean;
  /**
   * `s713` (приёмка штаба 05.10.2026): разговор открыт, а в текущий отбор списка слева не
   * входит (сменили фильтр на «Без ответа» — список пуст, а прежний разговор остался на
   * экране). Экран говорит это прямо и даёт закрыть разговор — чтобы открытое не читалось
   * как «найдено этим фильтром».
   */
  vneOtbora?: { onZakryt: () => void } | null;
  /**
   * `s720`: быстрый ответ из входящего уведомления. Шапки и переключателя хроники нет — контекст
   * даёт карточка уведомления; над полем та же полоса «кому / мессенджер / линия»; Enter в поле —
   * перенос строки, отправляет Ctrl+Enter или кнопка (слово задания).
   */
  mini?: boolean;
}

export function Razbor({ dannye, gruzitsya, onNazad, onOtkryt, vstroen: vstroenSnaruzhi = false, senderNearReply = false, onKlientka, klientkaSlovo, klientkaRyadom = false, klientkaVOkne = false, vneOtbora = null, mini = false }: Props) {
  // Мини-чат уведомления рисуется как встроенный: своей шапки и ряда ходов у него нет.
  const vstroen = vstroenSnaruzhi || mini;
  const text = useText();
  // s966: с дня X ссылки в УС («Открыть в УС», «Записать в УС») с экрана сняты.
  const bezUs = useBezUs();
  const label = useLabel();
  const { vypolnit, idyot, otkaz, sbrositOtkaz } = useHod(dannye?.id ?? null);
  // `s713` Д-09: черновик — свой у каждой беседы, а не один на экран.
  const [chernovik, setChernovik] = useChernovik(dannye?.id);
  const [ishchemKlientku, setIshchemKlientku] = useState(false);
  const [vybiraemPrichinu, setVybiraemPrichinu] = useState(false);
  /*
   * ⛔ ЗАКРЫВАЮЩЕЕ ДЕЙСТВИЕ СНАЧАЛА ГОВОРИТ, ЧТО БУДЕТ (владелец, 15.09, п.10:
   * «шаблоны действий над чатом не понятны — что для чего и что будет»).
   *
   * Подтверждение стоит ровно у тех двух кнопок, что ЗАКРЫВАЮТ обращение без
   * выбора причины. «Беру себе» подтверждения не просит: он обратим одним
   * нажатием соседа. «Отбросить» тоже не просит — у него и так шторка причины,
   * и второй вопрос поверх неё был бы вежливостью, а не защитой.
   */
  const [podtverzhdaem, setPodtverzhdaem] = useState<null | {
    ishod: "answered" | "booked";
    vopros: string;
  }>(null);
  /*
   * ⛔⛔ ПОДСКАЗКА ПО ДОЛГОМУ НАЖАТИЮ СНЯТА (`s605`, п.10-11 владельца: «вообще
   * не понял»).
   *
   * Удержание — жест, которого на этом экране никто не ждёт и о котором
   * неоткуда узнать: человек либо не находит объяснения вовсе, либо находит
   * его случайно, промахнувшись мимо нажатия. Объяснение, до которого надо
   * догадаться, — это объяснение, которого нет.
   *
   * Заменено не второй подсказкой, а устройством: у всех закрывающих действий
   * подтверждение говорит ПОЛНОЙ ФРАЗОЙ, что произойдёт и как вернуть. Текста
   * под кнопками при этом не появилось — op-rules §31.7 запрещает мелкие
   * шрифты и подписи-пояснения на экране, и правильный ответ здесь не «ещё
   * мелкий текст», а «нажатие само себя объясняет».
   */
  /*
   * ⛔ ФАЙЛ ПРИКРЕПЛЯЕТСЯ, А НЕ УЛЕТАЕТ (`s605`, п.13 владельца: «он сразу
   * отправился а не как обычно прикрепился к сообщению»).
   *
   * Выбранный файл живёт ЗДЕСЬ до нажатия «Отправить»: рядом с полем видно
   * превью, текст к нему становится подписью, убрать можно крестиком. Это
   * поведение любого мессенджера, и владелец сравнивал именно с ним.
   */
  const [pripisan, setPripisan] = useState<{
    fayl: File;
    predprosmotr: string | null;
  } | null>(null);
  const [otkladyvaem, setOtkladyvaem] = useState(false);
  const [vybiraemShablon, setVybiraemShablon] = useState(false);
  const [vybiraemMessendzher, setVybiraemMessendzher] = useState(false);
  const [menyuHodov, setMenyuHodov] = useState(false);
  const [peredaem, setPeredaem] = useState(false);
  const navigate = useNavigate();
  const zapisRyadom = useZapisRyadom();
  // Сквозная хроника (`s607`, Ф3): переключатель «этот диалог / вся хроника» и
  // ходы «Объединить»/«Разъединить».
  // Мини-чат показывает ЭТОТ диалог: отвечают на конкретное сообщение, а не на всю хронику.
  const [pokazHroniku, setPokazHroniku] = useState(vstroen && !mini);
  const [vybiraemDlyaObedineniya, setVybiraemDlyaObedineniya] = useState(false);
  const [podtverzhdaemObedinenie, setPodtverzhdaemObedinenie] = useState<null | { id: number }>(null);
  const [razedinyaem, setRazhedinyaem] = useState(false);
  const vyborFayla = useRef<HTMLInputElement | null>(null);
  // Диктовка кладёт распознанное В ПОЛЕ, а не отправляет: речь распознаётся с
  // ошибками всегда, и правит их человек.
  /*
   * ⛔ ОТКАЗ ДИКТОВКИ ГОВОРИТ СЛОВАМИ, А НЕ МОЛЧИТ (`s616`). Раньше шторка
   * объясняла ровно один случай — «браузер не умеет», — и он же был
   * единственным, который вообще мог случиться. Теперь пишут все браузеры, а
   * не выйти может другое: человек не дал микрофон, сервер не расслышал,
   * запись не собралась. Каждый случай обязан объяснить себя.
   */
  const [pochemuNeVyshlo, setPochemuNeVyshlo] = useState<string | null>(null);
  const { slushaem, rasshifrovyvaem, pereklyuchit } = useDiktovka(
    (tekst) => setChernovik(tekst),
    (pochemu) => setPochemuNeVyshlo(pochemu),
  );

  /*
   * Есть ли что отправлять — этим и решается, чем кончается строка ответа:
   * микрофоном или отправкой (владелец, 18.09.2026, `s608`).
   *
   * ⛔ ВО ВРЕМЯ ДИКТОВКИ — ВСЕГДА МИКРОФОН, сколько бы слов ни набежало.
   * Кнопка в конце одна; подмени её на отправку посреди диктовки — и
   * остановить диктовку станет нечем, а палец уже занесён над тем же местом.
   * Отправка появляется, когда диктовка кончилась и слова остались.
   */
  const estChtoOtpravit =
    !slushaem && !rasshifrovyvaem && (chernovik.trim() !== "" || pripisan !== null);

  /*
   * Куда ещё можно написать этой клиентке. ⛔ Считается ОДИН раз и на весь
   * экран: кнопка переключателя и лист выбора обязаны говорить об одном и том
   * же множестве, иначе кнопка появлялась бы над пустым листом.
   */
  const drugieMessendzhery = (dannye?.eyo_messendzhery ?? []).filter(
    (m) => !m.eto_tekushchiy,
  );
  /*
    ⛔ КНОПКА ПОЯВЛЯЕТСЯ ПО «ДРУГИМ», А ЛИСТ ПОКАЗЫВАЕТ ВСЕХ (`s615`, макет).
    Кнопка без других каналов обещала бы выбор, которого нет; лист без
    текущего не отвечает на вопрос «а откуда уходит сейчас».
  */
  const vseMessendzhery = dannye?.eyo_messendzhery ?? [];
  // ⛔ «Пока ты набирал, пришло вот это» — показывается ДО отправки, не после.
  const [novoePoyavilos, setNovoePoyavilos] = useState(false);
  /*
   * `s713` по контракту `s712`: блокировка редактирования переписки. Берётся, когда человек
   * поставил курсор в поле ответа; пока её держит другой — поле только читается, а ход всё
   * равно остановил бы сервер. Прежний сервер аренду не шлёт — тогда всё работает, как было.
   */
  const arenda = useArenda("inquiry", dannye?.id, dannye?.arenda);
  // `s720`: открытая на экране переписка не всплывает уведомлением («не дублировать активный
  // видимый диалог»). Мини-чат уведомления сам себя видимым диалогом не считает.
  useVidimyyDialog(dannye?.id, !mini);
  // `s713` Д-19: одно нажатие — одна отправка (правило и причина — у `odnoNazhatie` ниже).
  const vRabote = useRef(false);
  const [zametkaOtpravki, setZametkaOtpravki] = useState<string | null>(null);
  const qc = useQueryClient();

  /*
   * ⛔⛔ ЛЕНТА НЕ УЕЗЖАЕТ ПОД РУКОЙ, НО ОТКРЫВАЕТСЯ ВНИЗУ (`s605`: «еще чат куда
   * то прыгает вверх»).
   *
   * Прежняя редакция звала `scrollIntoView` на КАЖДОЕ изменение длины ленты —
   * то есть на каждое живое обновление раз в пять секунд. Человек листает
   * переписку вверх, читает, что клиентка писала утром, приходит новое
   * сообщение — и экран рывком уносит его вниз. Хуже того, `scrollIntoView`
   * крутит ВСЕХ прокручиваемых предков, включая саму страницу: на телефоне это
   * и выглядит как «чат прыгает вверх».
   *
   * ⛔⛔ А ПЕРВАЯ ПРАВКА `s605` СЛОМАЛА ВТОРУЮ ПОЛОВИНУ, И ПОЙМАЛ ЭТО ГЛАЗ НА
   * ЖИВОМ ЭКРАНЕ, А НЕ ЗАМЕР. Она уводила ленту вниз по смене `dannye.id` — но
   * в тот миг разговор ещё грузится, сообщений в дереве нет, и крутить нечего.
   * Когда они появлялись, замер «был ли человек внизу» честно отвечал «нет»
   * (прокрутка 0 при высоком содержимом) — и лента оставалась НАВЕРХУ, на
   * переписке недельной давности. Открыв чат, владелец не увидел бы ни
   * голосового, ни последнего «321».
   *
   * Поэтому «внизу ли человек» больше не единственный признак. Пока для ЭТОГО
   * разговора мы вниз ни разу не уводили, уводим — сколько бы раз лента ни
   * дорисовывалась. После этого работает обычное мессенджерское правило: новое
   * подтягивает только того, кто и так стоял внизу.
   */
  const oknoLenty = useRef<HTMLDivElement | null>(null);
  const bylVnizu = useRef(true);
  const otkryliVnizu = useRef<number | null>(null);

  const idBesedy = dannye?.id;
  const dlinaLenty = dannye?.lenta.length ?? 0;

  useLayoutEffect(() => {
    const okno = oknoLenty.current;

    if (okno === null || idBesedy === undefined) return;

    // Разговор ещё не отрисовался — крутить нечего, ждём следующей отрисовки.
    if (dlinaLenty === 0) return;

    if (otkryliVnizu.current !== idBesedy) {
      okno.scrollTop = okno.scrollHeight;
      otkryliVnizu.current = idBesedy;
      bylVnizu.current = true;

      return;
    }

    if (bylVnizu.current) {
      okno.scrollTop = okno.scrollHeight;
    }
  }, [idBesedy, dlinaLenty]);

  /*
   * Замер «внизу ли человек» — по событию прокрутки, а не на каждом рендере.
   * Запас в 80 точек: палец редко останавливает ленту ровно в конце.
   */
  useEffect(() => {
    const okno = oknoLenty.current;

    if (okno === null) return;

    const zapisat = () => {
      bylVnizu.current =
        okno.scrollHeight - okno.scrollTop - okno.clientHeight < 80;
    };

    okno.addEventListener("scroll", zapisat, { passive: true });

    return () => okno.removeEventListener("scroll", zapisat);
  }, []);

  /*
   * ⛔ СТРАХОВКА НА ДОРАСТАНИЕ ЛЕНТЫ. Место под картинку теперь известно до
   * загрузки, и главный источник скачка снят. Но высота может подрасти и по
   * другим поводам — перенос длинной строки, шрифт, приехавшая расшифровка, —
   * и тогда «конец» уезжает уже после того, как мы в него встали.
   *
   * Наблюдатель за размером доводит прокрутку ТОЛЬКО пока человек держится
   * низа. Отпустил, ушёл читать вверх — не трогаем: это и была исходная
   * жалоба «чат куда то прыгает вверх».
   */
  useEffect(() => {
    const okno = oknoLenty.current;

    if (okno === null || typeof ResizeObserver === "undefined") return;

    const nablyudatel = new ResizeObserver(() => {
      if (bylVnizu.current) okno.scrollTop = okno.scrollHeight;
    });

    nablyudatel.observe(okno);

    for (const ditya of Array.from(okno.children)) nablyudatel.observe(ditya);

    return () => nablyudatel.disconnect();
  }, [idBesedy]);

  if (gruzitsya && dannye === undefined) {
    return <div className="p-6 text-ops-caption text-ops-text-tertiary">…</div>;
  }

  if (dannye === undefined) return null;

  const { shapka, otvet_uydyot_ot: polosa, hody } = dannye;
  // `s635`: двери лида приезжают в блоке доски того же разбора (`KartochkaLida::blok`).
  const dveri = (dannye as Partial<RazborLida>).doska?.dveri;

  /*
   * ⛔ ПЕРЕД ОТПРАВКОЙ ЭКРАН ПОДТЯГИВАЕТ БЕСЕДУ (`s603`, Ф2). Дежурных несколько,
   * и набор ответа занимает секунды, за которые клиентка успевает дописать «а
   * можно завтра?», а второй дежурный — ответить сам. Отправь вслепую — и в
   * ленте окажется ответ не на то, что спросили последним, или вторая реплика
   * поверх чужой. Новое показывается ДО отправки: человек видит его и решает
   * сам. Второе нажатие отправляет — это НЕ запрет, а предупреждение.
   */
  /**
   * Приложить файл к ответу.
   *
   * ⛔ ПОДПИСЬ — ЭТО ТО, ЧТО УЖЕ НАБРАНО В ПОЛЕ. Дежурный пишет «вот наш
   * прайс», жмёт скрепку, выбирает файл — и текст обязан уйти ВМЕСТЕ с файлом,
   * а не остаться в поле вторым сообщением после.
   *
   * ⛔ ЧЕРНОВИК ЧИСТИТСЯ ТОЛЬКО ПОСЛЕ УСПЕХА. Отказ провайдера (файл велик,
   * окно суток закрыто) не должен стирать набранное: человек потерял бы текст
   * и не понял, за что.
   */
  const vybratFayl = (fayl: File) => {
    // Превью — только у картинок; у документа своё имя говорит больше эскиза.
    const predprosmotr = fayl.type.startsWith("image/")
      ? URL.createObjectURL(fayl)
      : null;

    setPripisan((bylo) => {
      if (bylo?.predprosmotr != null) URL.revokeObjectURL(bylo.predprosmotr);

      return { fayl, predprosmotr };
    });
  };

  /*
   * ⛔⛔ ОДНО НАЖАТИЕ «ОТПРАВИТЬ» — ОДНО СООБЩЕНИЕ (`s713` по контракту `s711`, Д-19 приёмки
   * 05.10.2026: четыре Enter дали четыре сообщения клиентке).
   *
   * Корень был здесь: Enter в поле не смотрел на «идёт отправка» (гасилась только кнопка),
   * а перед отправкой экран ещё сверял ленту — и всё это время признак «идёт» не стоял.
   *  · `vRabote` ставится СРАЗУ, до первой сетевой операции нажатия, и снимается по итогу:
   *    второй Enter и двойное нажатие кнопки ничего не начинают;
   *  · ключ намерения рождается тогда же и живёт до итога: повтор того же нажатия (обрыв
   *    связи, обновление страницы — `s720`) уходит с тем же ключом, и сервер клиентке второй
   *    раз не шлёт; после итога ключ снят — то же сообщение ещё раз уйдёт как новое;
   *  · другой текст, другой файл, другой шаблон — другое намерение и новый ключ.
   */
  const odnoNazhatie = async (
    soderzhanie: string,
    poslat: (klyuch: string) => Promise<RazborDannye>,
    pered?: () => Promise<boolean>,
  ): Promise<RazborDannye | null> => {
    if (vRabote.current) return null;
    vRabote.current = true;
    setZametkaOtpravki(null);

    try {
      // `s720`: ключ живёт в хранилище вкладки до итога — обрыв связи и обновление страницы
      // его не теряют (`chernoviki.ts`, `klyuchNamereniya`).
      const otpechatok = `${dannye.id}|${soderzhanie}`;
      const klyuch = klyuchNamereniya(otpechatok);

      if (pered !== undefined && !(await pered())) return null;

      const obnovitLentu = () => void qc.invalidateQueries({ queryKey: razborKey(dannye.id) });
      const vyshlo = await vypolnit(
        () => poslat(klyuch),
        (kod) => {
          // Страж `s712` (чужая блокировка, устаревшие данные): ход не сохранён — перечитываем
          // обращение; черновик остаётся в поле, человек проверяет и повторяет сам.
          if (kod !== null && (kod.startsWith("arenda.") || kod.startsWith("versiya."))) {
            obnovitLentu();
          }
          // Заново не шлём: сначала смотрим ленту — сообщение могло уйти.
          if (kod === "otpravka_eshchyo_idyot") {
            obnovitLentu();
            window.setTimeout(obnovitLentu, 3000);
          } else if (kod === "ishod_neizvesten" || kod === "klyuch_drugogo_namereniya") {
            snyatNamerenie(otpechatok);
            obnovitLentu();
          }
        },
      );

      if (vyshlo !== null) {
        snyatNamerenie(otpechatok);
        // Сервер узнал повтор — говорим его словом, а не молчим и не дублируем строку.
        if (vyshlo.otpravka?.namerenie?.povtor && vyshlo.otpravka.namerenie.slovo) {
          setZametkaOtpravki(vyshlo.otpravka.namerenie.slovo);
        }
      }

      return vyshlo;
    } finally {
      vRabote.current = false;
    }
  };

  const snyatFayl = () => {
    setPripisan((bylo) => {
      if (bylo?.predprosmotr != null) URL.revokeObjectURL(bylo.predprosmotr);

      return null;
    });
  };

  /**
   * Отправить прикреплённый файл вместе с набранным текстом — ОДНИМ ходом.
   *
   * ⛔ ЧЕРНОВИК ЧИСТИТСЯ ТОЛЬКО ПОСЛЕ УСПЕХА. Отказ (файл велик, окно суток
   * закрыто, диск не пишет) не должен стирать набранное: человек потерял бы
   * текст и не понял, за что.
   */
  const otpravitFayl = async () => {
    if (pripisan === null) return;

    const podpis = chernovik.trim();
    const f = pripisan.fayl;
    const vyshlo = await odnoNazhatie(
      `fayl|${f.name}|${f.size}|${f.lastModified}|${podpis}`,
      (klyuch) => prilozhit(dannye.id, f, podpis, klyuch),
    );

    if (vyshlo !== null) {
      setChernovik("");
      snyatFayl();
    }
  };

  /** Расшифровать одно голосовое строки ленты (п.8). */
  const rasshifrovatStroku = (stroka: number) =>
    vypolnit(() => rasshifrovat(dannye.id, stroka));

  const otpravit = async () => {
    const tekst = chernovik.trim();
    if (tekst === "") return;

    const vyshlo = await odnoNazhatie(
      `otvet|${tekst}`,
      (klyuch) => otvetit(dannye.id, tekst, klyuch),
      // ⛔ «Пока ты набирал, пришло вот это» — показывается ДО отправки, не после.
      async () => {
        if (novoePoyavilos) return true;

        const bylo = dannye.lenta.at(-1)?.id ?? null;
        const svezhiy = await fetchRazbor(dannye.id).catch(() => null);
        if (svezhiy === null) return true;

        const stalo = svezhiy.lenta.at(-1)?.id ?? null;
        if (stalo === bylo) return true;

        qc.setQueryData(razborKey(dannye.id), svezhiy);
        setNovoePoyavilos(true);

        return false;
      },
    );

    if (vyshlo !== null) {
      setChernovik("");
      setNovoePoyavilos(false);
    }
  };

  /*
   * ⛔⛔ КОЛОНКА ПЕРЕПИСКИ ПРЫГАЛА ПО ВЫСОТЕ ОТ ЧИСЛА СООБЩЕНИЙ (владелец,
   * приёмка 17.09.2026, п.3). Корень: корневой `<div>` ниже — единственный
   * ребёнок flex-колонки родителя (`ObrashcheniyaPage`) — не имел
   * `h-full`/`flex-1`, а у flex-элемента по умолчанию высота ПО СОДЕРЖИМОМУ,
   * не по родителю. Внутренний скролл ленты (`min-h-0 flex-1 overflow-y-auto`
   * ниже) настроен верно, но относительно ЭТОГО контейнера — а тот сам не
   * растягивался. `h-full` тянет карточку на всю высоту родителя (тот уже
   * фиксирован — `items-stretch`/`h-[calc(100dvh-…)]`); дальше растягивание
   * идёт по цепочке `min-h-0` как задумано.
   */
  return (
    <div className="flex h-full min-h-0 flex-col overflow-hidden rounded-ops-card border border-ops-border bg-ops-surface">
      {!vstroen && (<>
      {/* ── шапка ─────────────────────────────────────────────────────────── */}
      <div className="razbor-shapka relative flex items-center gap-2.5 border-b border-ops-border px-3 py-2.5">
        {onNazad && (
          <button
            type="button"
            onClick={onNazad}
            className="shrink-0 text-ops-text-secondary"
            aria-label="Назад"
          >
            <IconArrowLeft size={20} />
          </button>
        )}
        <ZnachokKanala
          kind={shapka.kanal_kind}
          color={shapka.filial.color}
          razmer={36}
        />
        <div className="min-w-0 flex-1">
          <div className="truncate text-ops-label font-medium text-ops-text">
            {shapka.customer_display ?? (
              <span className="text-ops-danger">
                {text("obrashcheniya.kto_eto")}
              </span>
            )}
          </div>
          <div className="flex items-center gap-x-2 overflow-hidden text-ops-micro text-ops-text-secondary [&>*]:shrink-0 [&>*:last-child]:truncate">
            {shapka.customer_id !== null && (
              <MaskaTelefona
                masked={shapka.telefon}
                entityType="customers"
                entityId={shapka.customer_id}
                bezZvonka
              />
            )}
            {!klientkaRyadom && (
            <span>
              {shapka.vizitov && shapka.vizitov > 0
                ? text("obrashcheniya.vizitov", { число: shapka.vizitov })
                : text("obrashcheniya.ni_razu")}
            </span>
            )}
            {/*
              ⛔ ДАТА ПОСЛЕДНЕГО ВИЗИТА — НЕ НА ТЕЛЕФОНЕ (`s605`, поймано глазом
              на 390). В одну линию шапки она не влезала последним знаком и
              читалась «26.11.202» — обрезанное число выглядит как поломка, а
              не как «не хватило места». Величина остаётся целиком в карточке,
              куда ведёт первая же строка меню.
            */}
            {shapka.posledniy_vizit !== null && !klientkaRyadom && (
              <span className="hidden sm:inline">{shapka.posledniy_vizit}</span>
            )}
          </div>
        </div>

        {/*
        ⛔⛔ ДЕЙСТВИЯ — В МЕНЮ, А НЕ РЯДОМ В СТРОКУ (макет Астры, 16.09; владелец:
        «то что я вижу не совпадает с дизайном астры абсолюнто»).

        Их пять-шесть, и в строку на 390 они не влезали никогда: «Отброс…»
        обрезалось на каждом скрине владельца. Ряд с прокруткой вбок был честной
        попыткой, но прокрутку у ряда действий никто не ищет — человек видит
        обрезанное слово и считает это поломкой.

        Меню открывается одной кнопкой и показывает всё сразу, на любой ширине.
        Ровно так же, как в мессенджере, с которым владелец сравнивает.
      */}
        {menyuHodov && (
          <button
            type="button"
            className="fixed inset-0 z-40 cursor-default"
            aria-label={text("obrashcheniya.otmena")}
            onClick={() => setMenyuHodov(false)}
          />
        )}

        {/*
          ⛔ С КАКОГО ПОДКЛЮЧЕНИЯ ИДЁТ ДИАЛОГ — НАВЕРХУ (владелец, 04.10.2026: «нужно явно
          писать с какого подключения идет диалог и перенести это наверх»; на скрине —
          «текущий номер подключения и тип (иконкой)»). Номер, без номера — логин, иначе
          подпись линии. Строка «Ответ уйдёт от» над полем ответа убрана: тот же факт, одно место.
        */}
        {senderNearReply && (
          <button
            type="button"
            className="messenger-connection"
            data-connection
            data-testid="kuda-liniya"
            data-smena={drugieMessendzhery.length > 0 ? "da" : "net"}
            // `s720`: линия одна — это вывеска, а не кнопка: мёртвого нажатия нет.
            disabled={idyot || arenda.tolkoProsmotr || drugieMessendzhery.length === 0}
            onClick={() => setVybiraemMessendzher(true)}
            title={drugieMessendzhery.length > 0 ? text("obrashcheniya.kuda.smenit") : undefined}
          >
            <ZnachokKanala kind={polosa.kanal_kind} color={polosa.color} razmer={20} />
            <span>{polosa.adres || polosa.kanal_podpis || shapka.kanal_kind_display}</span>
            {drugieMessendzhery.length > 0 && <IconChevronDown size={14} className="shrink-0" />}
          </button>
        )}

        {onKlientka !== undefined && (
          <button
            type="button"
            onClick={onKlientka}
            data-testid="knopka-klientka"
            className="shrink-0 inline-flex items-center gap-1.5 rounded-ops-pill border border-ops-border px-3 py-1.5 text-ops-label font-medium text-ops-text hover:border-ops-primary hover:text-ops-primary"
          >
            <IconUser size={18} /> {klientkaSlovo}
          </button>
        )}

        {senderNearReply && hody.razobrano && (
          <button
            type="button"
            data-testid="zakryt-perepisku"
            disabled={idyot}
            onClick={() => {
              setMenyuHodov(false);
              setPodtverzhdaem({ ishod: 'answered', vopros: text('obrashcheniya.podtverzhdenie_razobrano') });
            }}
            className="min-h-10 shrink-0 rounded-ops-pill border border-ops-primary px-2.5 py-1.5 text-ops-caption font-medium text-ops-primary hover:bg-ops-primary-soft disabled:opacity-50 sm:min-h-0"
          >
            {text('messenger.actions.close')}
          </button>
        )}

        <button
          type="button"
          onClick={() => setMenyuHodov((b) => !b)}
          disabled={idyot}
          title={text("obrashcheniya.deystviya")}
          aria-label={text("obrashcheniya.deystviya")}
          className="shrink-0 rounded-ops-pill p-1 text-ops-text-secondary hover:bg-ops-surface-2 hover:text-ops-primary disabled:opacity-40"
        >
          <IconDotsVertical size={20} />
        </button>

        {menyuHodov && (
          <div
            /*
              ⛔ МЕНЮ ЛИСТАЕТСЯ (`s698`, менеджер 04.10.2026: «шаблонов тут нет,
              вниз оно не листается»). На невысоком экране список ходов уходил
              под нижний край окна и обрезался: `overflow-hidden` без высоты.
              Высота считается от места, где меню открылось, до края окна —
              при любом масштабе браузера.
            */
            ref={(el) => {
              if (el !== null) {
                const verh = el.getBoundingClientRect().top;
                el.style.maxHeight = `${Math.max(160, window.innerHeight - verh - 12)}px`;
              }
            }}
            className="absolute right-2 top-full z-50 mt-1 min-w-[230px] overflow-y-auto overscroll-contain rounded-ops-card border border-ops-border bg-ops-surface shadow-ops-drop"
          >
            {/*
              ⛔ ПОДПИСЬ — ТОЛЬКО НА ТЕЛЕФОНЕ (макет владельца, `s615`, экран 3:
              «Меню ⋮ открывается снизу на телефоне»). На столе меню выпадает
              У САМОЙ КНОПКИ, и подписывать его незачем: видно, от чего оно.
              На узком экране то же меню приезжает снизу во всю ширину, и без
              подписи это список слов неизвестно к чему — там она обязательна.
            */}
            <div className="flex h-12 items-center gap-2 px-3.5 text-ops-caption font-semibold text-ops-text sm:hidden">
              <span className="min-w-0 flex-1 truncate">
                {text("obrashcheniya.deystviya_s_dialogom")}
              </span>
              <button
                type="button"
                onClick={() => setMenyuHodov(false)}
                aria-label={text("obrashcheniya.otmena")}
                className="shrink-0 text-ops-text-tertiary hover:text-ops-text"
              >
                <IconX size={18} />
              </button>
            </div>
            {/*
              ⛔ «ШАБЛОН» — ПЕРВЫМ И ВСЕГДА (владелец, 04.10.2026, `s698`:
              «перенеси пункт "шаблоны" в самый верх списка»). Он стоял
              предпоследним и при закрытом суточном окне из меню пропадал —
              менеджер искала его здесь и не нашла.
            */}
            <HodStrokoy
              znachok={<IconFileDescription size={16} />}
              slovo={text("obrashcheniya.shablon")}
              onClick={() => {
                setMenyuHodov(false);
                setVybiraemShablon(true);
              }}
            />
            {/*
              ⛔ «ОТКРЫТЬ КАРТОЧКУ» — ТОЖЕ ХОД, И ЖИВЁТ ТАМ ЖЕ, ГДЕ ОСТАЛЬНЫЕ
              (`s605`, поймано глазом на 390 сразу после выкатки).

              Ссылка стояла в шапке рядом с именем и телефоном и отжимала их:
              на телефоне шапка разъезжалась в ТРИ строки — имя, маска телефона,
              «была 1 раз» и дата вставали друг под друга и ели высоту ленты.
              Одно место для всех ходов (§31.8) оказалось и единственным, где
              ей хватает ширины на любом экране.
            */}
            {/*
              ⛔ ВЫБОР МЕССЕНДЖЕРА ИЗ МЕНЮ УБРАН (владелец, 18.09.2026, `s608`:
              «кнопка выбора мессенджера, если их несколько, напрашивается сюда
              из трех точек»). Он переехал в ряд «этот диалог / вся хроника» —
              там, где человек и спрашивает себя, в каком канале он сейчас.
              Двух мест у одного действия не бывает (§31.8).
            */}
            {shapka.customer_id !== null && (
              <Link
                to={`/clients/${shapka.customer_id}`}
                onClick={() => setMenyuHodov(false)}
                className="flex w-full items-center gap-2.5 px-3 py-2.5 text-left text-ops-caption text-ops-text hover:bg-ops-surface-2"
              >
                <span className="shrink-0">
                  <IconUser size={16} />
                </span>
                {text("obrashcheniya.otkryt_kartochku")}
              </Link>
            )}
            {hody.vernut && (
              <HodStrokoy
                znachok={<IconArrowBackUp size={16} />}
                slovo={text("obrashcheniya.vernut")}
                onClick={() => {
                  setMenyuHodov(false);
                  void vypolnit(() => vernut(dannye.id));
                }}
              />
            )}
            {hody.beru && (
              <HodStrokoy
                znachok={<IconUser size={16} />}
                slovo={text("obrashcheniya.beru")}
                onClick={() => {
                  setMenyuHodov(false);
                  void vypolnit(() => vzyat(dannye.id));
                }}
              />
            )}
            {hody.zapisala && (
              <HodStrokoy
                znachok={<IconCalendarPlus size={16} />}
                slovo={text("obrashcheniya.zapisala")}
                onClick={() => {
                  setMenyuHodov(false);
                  setPodtverzhdaem({
                    ishod: "booked",
                    vopros: text("obrashcheniya.podtverzhdenie_zapisala"),
                  });
                }}
              />
            )}
            {/*
              `s635` (ТЗ v3 §4.13): двери лида `s633` в очереди — «Записать»,
              «Передать», «В обзвон», «Не дозвонилась». «Записать» работает уже
              сейчас (`[s635-zapisat]`): окно новой записи журнала с клиенткой —
              тем же выражением, что в карточке лида.
            */}
            {dveri?.zapisat && (
              <HodStrokoy
                znachok={<IconCalendarPlus size={16} />}
                slovo={text("doska.karta.zapisat")}
                onClick={() => {
                  setMenyuHodov(false);
                  /* ⛔ `s677`: есть поставщик — расписание открывается РЯДОМ с
                     перепиской; нет (лайт-переписка) — прежний путь в журнал. */
                  if (zapisRyadom !== null) {
                    zapisRyadom(zapisIzRazbora(dannye));

                    return;
                  }
                  const put = putZapisiIzLida(dannye);
                  navigate(put.to, { state: put.state });
                }}
              />
            )}
            {dveri?.peredat && (
              <HodStrokoy
                znachok={<IconUser size={16} />}
                slovo={text("doska.karta.peredat")}
                onClick={() => {
                  setMenyuHodov(false);
                  setPeredaem(true);
                }}
              />
            )}
            {dveri?.v_obzvon && (
              <HodStrokoy
                znachok={<IconPhone size={16} />}
                slovo={text("doska.karta.v_obzvon")}
                onClick={() => {
                  setMenyuHodov(false);
                  void vypolnit(() => lidVObzvon(dannye.id));
                }}
              />
            )}
            {dveri?.ne_dozvonilas && (
              <HodStrokoy
                znachok={<IconPhoneOff size={16} />}
                slovo={text("doska.karta.ne_dozvonilas")}
                onClick={() => {
                  setMenyuHodov(false);
                  void vypolnit(() => neDozvonilas(dannye.id));
                }}
              />
            )}
            {hody.razobrano && !senderNearReply && (
              <HodStrokoy
                znachok={<IconCheck size={16} />}
                slovo={text("obrashcheniya.razobrano")}
                onClick={() => {
                  setMenyuHodov(false);
                  setPodtverzhdaem({
                    ishod: "answered",
                    vopros: text("obrashcheniya.podtverzhdenie_razobrano"),
                  });
                }}
              />
            )}
            {hody.otlozhit && (
              <HodStrokoy
                znachok={<IconPlayerPause size={16} />}
                slovo={text("obrashcheniya.otlozhit")}
                onClick={() => {
                  setMenyuHodov(false);
                  setOtkladyvaem(true);
                }}
              />
            )}
            {hody.vernut_iz_otlozhennyh && (
              <HodStrokoy
                znachok={<IconPlayerPlay size={16} />}
                slovo={text("obrashcheniya.vernut_iz_otlozhennyh")}
                onClick={() => {
                  setMenyuHodov(false);
                  void vypolnit(() => vernutIzOtlozhennyh(dannye.id));
                }}
              />
            )}
            {hody.eto_klientka && !klientkaVOkne && (
              <HodStrokoy
                znachok={<IconFileDescription size={16} />}
                slovo={text("obrashcheniya.eto_klientka")}
                onClick={() => {
                  setMenyuHodov(false);
                  setIshchemKlientku(true);
                }}
              />
            )}
            {hody.novaya_klientka && !klientkaVOkne && (
              <HodStrokoy
                znachok={<IconUserPlus size={16} />}
                slovo={text("obrashcheniya.novaya_klientka")}
                onClick={() => {
                  setMenyuHodov(false);
                  void vypolnit(() => novayaKlientka(dannye.id, null));
                }}
              />
            )}
            {/*
              ⛔ СВЯЗЬ, А НЕ СЛИЯНИЕ (`s607`, Ф3). «Объединить» кладёт обратимую
              строку связи двух карточек, «Разъединить» её убирает. Физически
              ничего не склеивается — сходится только витрина хроники.
            */}
            {shapka.customer_id !== null && (
              <HodStrokoy
                znachok={<IconLink size={16} />}
                slovo={text("obrashcheniya.obedinit")}
                onClick={() => {
                  setMenyuHodov(false);
                  setVybiraemDlyaObedineniya(true);
                }}
              />
            )}
            {shapka.customer_id !== null && dannye.svyazannye.length > 0 && (
              <HodStrokoy
                znachok={<IconLinkOff size={16} />}
                slovo={text("obrashcheniya.razedinit")}
                onClick={() => {
                  setMenyuHodov(false);
                  setRazhedinyaem(true);
                }}
              />
            )}
            {/*
              ⛔⛔ «Шаблон» ЖИВОЙ И НА ВСЕХ КАНАЛАХ (`s606`, Ф3). `s604`
              выключила его со словом «согласованных шаблонов не бывает нигде,
              кроме WhatsApp» — и это правда только про ОДИН из двух родов.

              Согласованные (их утверждает Meta через провайдера) есть
              действительно только у WhatsApp, и они единственное, чем можно
              написать при закрытом суточном окне. Но НАШИ заготовки — обычные
              слова, и «наш адрес» нужен в Telegram ровно так же. Оставить
              кнопку выключенной везде значило бы спрятать половину дела.
            */}
            {/*
              ⛔ Пока окно закрыто, ход «шаблон» стоит НА МЕСТЕ ПОЛЯ ОТВЕТА —
              там, куда человек смотрит, когда поля нет (`s608`). Здесь он в
              это время не рисуется: одно действие — одно место (§31.8).
            */}
            {/* `s698`: «Шаблон» переехал первым пунктом меню — см. верх списка. */}
            {/*
              ⛔ ОТБРОСИТЬ — ПОСЛЕДНИМ И КРАСНЫМ (макет Астры). Это отказ от
              работы с человеком, а не разбор: он не должен стоять рядом с
              «Записала на визит» и выглядеть так же.
            */}
            {hody.otbrosit && (
              <HodStrokoy
                znachok={<IconTrash size={16} />}
                slovo={text("obrashcheniya.otbrosit")}
                opasnyy
                onClick={() => {
                  setMenyuHodov(false);
                  setVybiraemPrichinu(true);
                }}
              />
            )}
          </div>
        )}
      </div>

      {/*
        `s720`: полоса «Ответ уйдёт от» отсюда снята — тот же факт, полнее (кому, мессенджер,
        наша линия и её номер), стоит над полем ответа (`PolosaKudaUydyot`): одна величина —
        одно место (§31.8), и стоит она там, куда человек смотрит перед «Отправить».
      */}

      {/* ── переключатель «этот диалог / вся хроника» (`s607`, Ф3) ────────── */}
      <div className="razbor-vkladki flex items-center gap-1 border-b border-ops-border px-3 py-1.5">
        {(
          [
            [false, text("obrashcheniya.etot_dialog")],
            [true, text("obrashcheniya.vsya_hronika")],
          ] as const
        ).map(([znachenie, slovo]) => (
          <button
            key={String(znachenie)}
            type="button"
            onClick={() => setPokazHroniku(znachenie)}
            className={cn(
              "rounded-ops-pill px-3 py-1 text-ops-caption",
              pokazHroniku === znachenie
                ? "bg-ops-primary text-ops-on-primary"
                : "text-ops-text-secondary hover:bg-ops-surface-2",
            )}
          >
            {slovo}
          </button>
        ))}

        {/*
          ⛔⛔ ВЫБОР МЕССЕНДЖЕРА СТОИТ ЗДЕСЬ (владелец, 18.09.2026, `s608`, с
          боевого телефона: «кнопка выбора мессенджера, если их несколько,
          напрашивается сюда из трех точек» — с указанием на этот самый ряд).

          Путь этой кнопки за день: полоса из трёх больших пилюль под
          перепиской (ела до трёх строк — четверть экрана) → строки в меню
          «⋮» → сюда. Ряд уже есть, своей высоты кнопка не занимает, а рядом
          с «этот диалог / вся хроника» она читается как то, чем и является:
          «в каком канале я сейчас и куда могу переключиться».

          ⛔ ПОКАЗЫВАЕТСЯ, ТОЛЬКО ЕСЛИ ЕСТЬ КУДА ПЕРЕКЛЮЧАТЬСЯ («если их
          несколько» — слово владельца). Один канал — кнопки нет: она бы
          обещала выбор, которого не существует.

          ⛔ НОМЕР НАЗЫВАЕТСЯ В ЛИСТЕ, А НЕ НА КНОПКЕ (`s614`: у клиники два
          WhatsApp): на кнопке ему не хватит места ни на одном телефоне, а
          неподписанный значок вёл бы в соседний номер.
        */}
        {/*
          `s720`: кнопка выбора мессенджера из этого ряда снята — одно действие в одном месте
          (§31.8). Линия теперь выбирается там, где она названа: в «Переписках» — плашкой
          подключения в шапке (слово владельца 04.10.2026 «перенести наверх»), в остальных местах —
          в полосе «Кому / мессенджер / С линии» над полем ответа. Две кнопки одного выбора на
          одном экране вели бы в один и тот же лист.
        */}
      <NashiMessendzhery key={dannye.id} inquiryId={dannye.id} rows={dannye.nashi_messendzhery ?? []} />
      </div>

      {/* ── лента ─────────────────────────────────────────────────────────── */}
      {/*
        `s705`, корректировка владельца 05.10.2026: «в лидах и переписках показывать актуальные сведения
        записи и ссылку „Открыть в УС“ на конкретную запись правильного филиала». Сведения — нашей копии
        (её обновляет синхронизация), строка перечитывается тем же опросом разбора, без перезагрузки.
      */}
      {(() => {
        const dz = (dannye as Partial<RazborLida>).doska;
        const z = dz?.zapis ?? null;
        if (z === null && (bezUs || !(dz?.us?.vedyot && dz.us.zhurnal !== null))) return null;

        return (
          <div className="flex flex-wrap items-center gap-x-3 gap-y-1 border-b border-ops-border bg-ops-surface-2 px-3 py-1.5 text-ops-micro text-ops-text-secondary" data-testid="perepiska-zapis">
            <IconCalendarCheck size={16} className="shrink-0" />
            {z !== null ? (
              <>
                <span className="font-medium text-ops-text">{z.data}, {z.vremya}</span>
                {z.master !== null && <span>{z.master}</span>}
                {z.usluga !== null && <span className="max-w-[40ch] truncate">{z.usluga}</span>}
                {(z.bron ?? z.status) !== null && <span>{z.bron ?? z.status}</span>}
                {!bezUs && z.ssylka_us != null && (
                  <a className="ml-auto inline-flex items-center gap-1 font-medium text-ops-primary" href={z.ssylka_us} target="_blank" rel="noopener noreferrer" data-testid="perepiska-zapis-v-us">
                    <IconExternalLink size={14} />
                    {text("doska.karta.otkryt_v_us")}
                  </a>
                )}
              </>
            ) : (
              <>
                <span>{text("doska.karta.zapis_net_us")}</span>
                <a className="ml-auto inline-flex items-center gap-1 font-medium text-ops-primary" href={dz!.us!.zhurnal!} target="_blank" rel="noopener noreferrer" data-testid="perepiska-zapisat-v-us">
                  <IconExternalLink size={14} />
                  {text("doska.karta.zapisat_v_us")}
                </a>
              </>
            )}
          </div>
        );
      })()}
      </>)}

      {vneOtbora !== null && (
        <div className="flex items-center gap-2 border-t border-ops-border bg-ops-info-soft px-3 py-2 text-ops-caption text-ops-info" role="status" data-testid="vne-otbora">
          <span className="min-w-0 flex-1">{text("obrashcheniya.vne_otbora")}</span>
          <button type="button" onClick={vneOtbora.onZakryt} className="shrink-0 rounded-ops-md border border-current px-3 py-1.5 font-medium" data-testid="vne-otbora-zakryt">
            {text("obrashcheniya.vne_otbora_zakryt")}
          </button>
        </div>
      )}

      <div
        ref={oknoLenty}
        data-lenta-obrashcheniya
        className="min-h-0 flex-1 overflow-y-auto bg-ops-bg px-3 py-2"
      >
        {pokazHroniku ? (
          <LentaHroniki
            nachalo={dannye.hronika}
            color={dannye.shapka.filial.color}
            klyuch={dannye.shapka.customer_id}
            zagruzit={(k) => fetchHronikaObrashcheniya(dannye.id, k)}
          />
        ) : dannye.lenta.length === 0 ? (
          <p className="py-8 text-center text-ops-caption text-ops-text-tertiary">
            {text("obrashcheniya.net_perepiski")}
          </p>
        ) : (
          <Puzyri
            lenta={dannye.lenta}
            onRasshifrovat={rasshifrovatStroku}
            zanyat={idyot}
          />
        )}
      </div>

      {/* ── отказ машины — её словами ─────────────────────────────────────── */}
      {otkaz !== null && (
        <div className="flex items-center gap-2 border-t border-ops-border bg-ops-danger-soft px-3 py-2 text-ops-caption text-ops-danger">
          <span className="flex-1">{otkaz}</span>
          <button
            type="button"
            onClick={sbrositOtkaz}
            className="underline underline-offset-2"
          >
            {text("obrashcheniya.povtorit")}
          </button>
        </div>
      )}

      {zametkaOtpravki !== null && (
        <div className="border-t border-ops-border bg-ops-info-soft px-3 py-2 text-ops-caption text-ops-info" data-testid="zametka-otpravki">
          {zametkaOtpravki}
        </div>
      )}

      {novoePoyavilos && (
        <div className="border-t border-ops-border bg-ops-info-soft px-3 py-2 text-ops-caption text-ops-info">
          {text("obrashcheniya.poka_nabiral")}
        </div>
      )}

      {/* ── предупреждение о чужом держателе: не запрет ───────────────────── */}
      {/* `s713`: блокировку редактирования называет своя полоса — прежнее «держит …» при ней не дублируем. */}
      {/*
        `s720` по просьбе `s719` (слова владельца на приёмке 06.10.2026: «надпись „держит Наталья —
        всё равно ответить?“ не должна позволять обойти блокировку»). Предупреждение «держит … —
        всё равно ответить» снято: «держит» теперь значит блокировку редактирования, её называет
        полоса выше, и при чужой блокировке всё отправляющее на этом экране выключено.
      */}
      <PolosaArendy a={arenda} />

      {/*
        ⛔ ОТЛОЖЕННОСТЬ ВИДНА В САМОМ РАЗГОВОРЕ, а не только в списке: дежурный
        открыл строку и обязан сразу понять, почему она молчит (`s605`, п.6).
      */}
      {dannye.otlozheno !== null && (
        <div className="border-t border-ops-border bg-ops-info-soft px-3 py-2 text-ops-caption text-ops-info">
          {dannye.otlozheno.prichina_display} ·{" "}
          {text("obrashcheniya.otlozheno_do_display", {
            время: dannye.otlozheno.do_display,
          })}
          {dannye.otlozheno.zametka !== null &&
            ` · ${dannye.otlozheno.zametka}`}
        </div>
      )}

      {/* ── ряд действий ──────────────────────────────────────────────────── */}
      {/*
       * ⛔ ВОПРОС СТОИТ У КНОПОК, А НЕ ВНИЗУ ЭКРАНА. Первая редакция рисовала
       * подтверждение после поля ввода — поймал глаз на живом экране: вопрос
       * уехал под поле «Сообщение», и на телефоне его пришлось бы искать
       * прокруткой, нажав кнопку наверху. Вопрос о нажатии живёт там же, где
       * нажатие.
       */}
      {peredaem && (dannye as Partial<RazborLida>).doska !== undefined && (
        <div className="uchastok-zapisi">
          <Peredat
            lyudi={(dannye as RazborLida).doska.peredat.lyudi}
            prichiny={(dannye as RazborLida).doska.peredat.prichiny}
            onOtmena={() => setPeredaem(false)}
            onGotovo={(userId, prichina) => {
              setPeredaem(false);
              void vypolnit(() => peredatLid(dannye.id, userId, prichina));
            }}
          />
        </div>
      )}

      {podtverzhdaem !== null && (
        <Podtverzhdenie
          vopros={podtverzhdaem.vopros}
          da={text("obrashcheniya.podtverdit")}
          otmena={text("obrashcheniya.peredumal")}
          zanyat={idyot}
          onDa={() => {
            const ishod = podtverzhdaem.ishod;
            setPodtverzhdaem(null);
            void vypolnit(() => razobrano(dannye.id, ishod));
          }}
          onOtmena={() => setPodtverzhdaem(null)}
        />
      )}

      {/* ── поле ответа либо честное «только шаблоном» ────────────────────── */}
      {!senderNearReply && (
        <PolosaKudaUydyot
          dannye={dannye}
          mozhnoSmenit={drugieMessendzhery.length > 0}
          onSmenit={() => setVybiraemMessendzher(true)}
          zanyat={idyot || arenda.tolkoProsmotr}
          // В мини-чате уведомления «Шаблоны» в полосу не ставим: места мало, а при закрытом окне
          // 24 часов ход «шаблон» и так встаёт на место поля.
          sprava={vstroenSnaruzhi && !hody.okno.tolko_shablonom ? (
            <button
              type="button"
              disabled={idyot || arenda.tolkoProsmotr}
              onClick={() => setVybiraemShablon(true)}
              className="flex shrink-0 items-center gap-1.5 rounded-ops-md border border-ops-border px-3 py-1.5 text-ops-caption text-ops-text hover:border-ops-primary disabled:opacity-50"
            >
              <IconFileDescription size={16} />
              {text("doska.karta.shablony")}
            </button>
          ) : undefined}
        />
      )}

      {hody.okno.tolko_shablonom ? (
        /*
          ⛔⛔ ВНЕ ОКНА — НЕ НАДПИСЬ, А САМ ХОД (`s608`, 18.09.2026; слово
          владельца: «вацвап офф - ответить шаблоном только ВНЕ окна 24 часа,
          в рамках окна можно писать что угодно»).

          Здесь стояла одна строка «Ответить можно только шаблоном» — и всё.
          Экран честно называл ограничение и не давал ничего сделать: ход
          лежал в меню «⋮», куда в этот момент никто не идёт. Человек видит
          отсутствие поля, читает запрет и уходит, считая разговор тупиком.

          ⛔ ДЕЙСТВИЕ ОСТАЁТСЯ В ОДНОМ МЕСТЕ (§31.8): пока окно закрыто, ход
          живёт ЗДЕСЬ и из меню убран; пока открыто — наоборот. Двух кнопок
          «шаблон» на экране не бывает ни в одном состоянии.
        */
        <div className="flex flex-col items-stretch gap-2 border-t border-ops-border px-3 py-3">
          <span className="text-center text-ops-caption text-ops-warning">
            {text("obrashcheniya.tolko_shablonom")}
          </span>
          <button
            type="button"
            disabled={idyot || arenda.tolkoProsmotr}
            onClick={() => setVybiraemShablon(true)}
            className="flex w-full items-center justify-center gap-2 rounded-ops-pill bg-ops-primary px-4 py-2.5 text-ops-body font-medium text-ops-on-primary disabled:opacity-40"
          >
            <IconFileDescription size={18} />
            {text("obrashcheniya.shablon")}
          </button>
        </div>
      ) : (
        <>
          {/*
          ⛔ ПРИКРЕПЛЁННОЕ ВИДНО ДО ОТПРАВКИ (`s605`, п.13). Владелец сравнивал
          с обычным мессенджером — там файл встаёт превью рядом с полем, текст
          становится подписью, и уходит всё одним нажатием. Раньше файл улетал
          в тот же миг, без текста и без права передумать.
        */}
          {pripisan !== null && (
            <div className="flex items-center gap-2 border-t border-ops-border bg-ops-surface-muted px-3 py-2">
              {pripisan.predprosmotr !== null ? (
                <img
                  src={pripisan.predprosmotr}
                  alt=""
                  width={40}
                  height={40}
                  className="h-10 w-10 shrink-0 rounded-ops-sm object-cover"
                />
              ) : (
                <IconFile
                  size={20}
                  className="shrink-0 text-ops-text-secondary"
                />
              )}
              <span className="min-w-0 flex-1 truncate text-ops-caption text-ops-text">
                {pripisan.fayl.name}
              </span>
              <span className="shrink-0 text-ops-caption text-ops-text-secondary">
                {text("obrashcheniya.vlozhenie_gotovo")}
              </span>
              <button
                type="button"
                onClick={snyatFayl}
                aria-label={text("obrashcheniya.vlozhenie_snyat")}
                title={text("obrashcheniya.vlozhenie_snyat")}
                className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full text-ops-text-tertiary hover:bg-ops-surface-2 hover:text-ops-danger"
              >
                <IconX size={16} />
              </button>
            </div>
          )}
          {/*
            ⛔⛔ СТРОКА ОТВЕТА — КАК В МЕССЕНДЖЕРЕ (владелец, 18.09.2026, `s608`,
            дословно: «поле сообщение сделай как в тг широким, там как-то влезло
            все в одну строку а тут в два раза уже!! кнопку прикрепить файл
            можно внести в начало строки ввода, фотку микрофона в конец и она
            подменяется отправить в момент ввода собщения или после
            надиктовывания»).

            Было: четыре предмета в ряд — скрепка, микрофон, поле, отправка. На
            390 точках поле получало меньше половины ширины, и написанное не
            помещалось в строку. Стало: скрепка ВНУТРИ поля слева, поле на всю
            оставшуюся ширину, и ОДНА круглая кнопка в конце.

            ⛔ МИКРОФОН ПО-ПРЕЖНЕМУ ВИДЕН ВСЕГДА (`s605`, п.15 владельца:
            «микрофона на компе не вижу»). Прежнее правило не отменено: пока
            отправлять нечего — а это обычное состояние строки — в конце стоит
            именно микрофон. Он уступает место отправке только тогда, когда
            отправка ЕСТЬ: написали слово, надиктовали или прикрепили файл.

            ⛔ И ОДНА КНОПКА ОТПРАВКИ (`s605`, п.13-14, op-rules §31.8) тоже
            цела: кнопка в конце одна на текст и на файл, второй не заведено.

            ⛔ ВО ВРЕМЯ ДИКТОВКИ КНОПКА ОСТАЁТСЯ МИКРОФОНОМ, даже когда слова
            уже набежали: иначе остановить диктовку стало бы нечем — единственная
            кнопка превратилась бы в отправку прямо под пальцем.
          */}
          {/*
            ⛔⛔ СТРОКА ОТВЕТА — КАК В МЕССЕНДЖЕРЕ (владелец, 18.09.2026, `s608`).

            Первое слово: «поле сообщение сделай как в тг широким, там как-то
            влезло все в одну строку а тут в два раза уже!!». Второе, с боевого
            телефона: «поле вводы - НА ВСЮ ШИРИНУ отступ от краев экрана
            минимальный технический, как в тг» и «микрофон и кнопку отправки
            внутрь поля ввода как скрепка!!».

            Стало: ряд отступает от краёв на 8 точек — ровно столько, чтобы
            кольцо фокуса не срезалось краем. Всё остальное внутри одного поля:
            скрепка слева, ход справа. Отдельных предметов в ряду больше нет.

            ⛔ ХОДЫ ЛЕЖАТ ПОВЕРХ ПОЛЯ, А НЕ ВНУТРИ КОРОБКИ. У системы общее
            правило `.ops-skin :focus-visible` — оно рисует кольцо вокруг того,
            что получило фокус. Положи поле внутрь коробки — и кольцо выйдет
            ПРЯМОУГОЛЬНИКОМ внутри круглого поля (поймано глазом на подписи
            телефона, §27.1). Поле само остаётся пилюлей, кнопки лежат сверху,
            а поле отступает под них отбивкой.

            ⛔ МИКРОФОН ВИДЕН ВСЕГДА (`s605`, п.15) — пока отправлять нечего, а
            это обычное состояние строки. ⛔ ОДНА КНОПКА ОТПРАВКИ на текст и на
            файл (`s605`, п.13-14; §31.8) — она же. ⛔ ВО ВРЕМЯ ДИКТОВКИ кнопка
            остаётся микрофоном, иначе остановить диктовку станет нечем.
          */}
          <div className="border-t border-ops-border px-2 py-2">
            {/* ⛔ Скрепка (владелец, п.6). Поле выбора спрятано, а не стилизовано:
              родной вид `input[type=file]` в каждом браузере свой и ни в одном
              не похож на остальную панель. */}
            <input
              ref={vyborFayla}
              type="file"
              hidden
              accept="image/jpeg,image/png,image/webp,image/gif,application/pdf,.doc,.docx,.xls,.xlsx,.txt"
              onChange={(e) => {
                const f = e.target.files?.[0];
                // Значение сбрасывается всегда: иначе второй выбор ТОГО ЖЕ файла
                // не поднимет события вовсе, и дежурный решит, что кнопка умерла.
                e.target.value = "";

                if (f !== undefined) vybratFayl(f);
              }}
            />

            <div className="relative flex items-end">
              <button
                type="button"
                onClick={() => vyborFayla.current?.click()}
                disabled={idyot || arenda.tolkoProsmotr}
                aria-label={text("obrashcheniya.prilozhit")}
                title={text("obrashcheniya.prilozhit")}
                className="absolute bottom-1 left-1.5 z-10 flex h-9 w-9 shrink-0 items-center justify-center rounded-full text-ops-text-secondary transition-colors hover:bg-ops-surface-2 hover:text-ops-primary disabled:opacity-40"
              >
                <IconPaperclip size={18} />
              </button>

              {/* `s713` Д-09: поле растёт до пяти строк; Enter отправляет, как и раньше. */}
              <PoleOtveta
                tekst={chernovik}
                onTekst={(novyy) => {
                  arenda.otmetitAktivnost();
                  setChernovik(novyy);
                }}
                onNachalo={() => void arenda.vzyat()}
                tolkoChtenie={arenda.tolkoProsmotr}
                onOtpravit={() => void (pripisan !== null ? otpravitFayl() : otpravit())}
                placeholder={label("obr_pole_soobshcheniya")}
                enterPerenosit={mini}
              />

              {estChtoOtpravit ? (
                <button
                  type="button"
                  onClick={() =>
                    void (pripisan !== null ? otpravitFayl() : otpravit())
                  }
                  disabled={idyot || arenda.tolkoProsmotr}
                  aria-label={text("obrashcheniya.otpravit")}
                  title={mini ? text("obrashcheniya.bystryy_otvet_podskazka") : text("obrashcheniya.otpravit")}
                  data-testid="otpravit"
                  className="absolute bottom-1 right-1.5 z-10 flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-ops-primary text-ops-on-primary transition-colors disabled:opacity-40"
                >
                  <IconSend size={18} />
                </button>
              ) : (
                /*
                 * ⛔ КНОПКА В КОНЦЕ ОДНА, И ВО ВРЕМЯ ЗАПИСИ ОНА ОСТАЁТСЯ
                 * МИКРОФОНОМ (правила `s605`/`s608`, целы). Состояние
                 * передаётся цветом: красная — пишем, приглушённая — сервер
                 * расшифровывает. Второй иконки «стоп» нет намеренно: палец
                 * уже занесён над этим местом, и подмена значка под пальцем
                 * означала бы нажать не то.
                 *
                 * ⛔ БЛЕДНОЙ «НЕ УМЕЕТ» БОЛЬШЕ НЕТ. Записывать умеют все
                 * браузеры, включая Firefox, — прятать и гасить нечего.
                 */
                <button
                  type="button"
                  onClick={() => pereklyuchit()}
                  disabled={rasshifrovyvaem}
                  aria-label={text("obrashcheniya.nadiktovat")}
                  title={text("obrashcheniya.nadiktovat")}
                  className={cn(
                    "absolute bottom-1 right-1.5 z-10 flex h-9 w-9 shrink-0 items-center justify-center rounded-full transition-colors",
                    slushaem
                      ? "bg-ops-danger text-white"
                      : rasshifrovyvaem
                        ? "bg-ops-surface-2 text-ops-text-tertiary"
                        : "text-ops-text-secondary hover:bg-ops-surface-2 hover:text-ops-primary",
                  )}
                >
                  <IconMicrophone size={18} />
                </button>
              )}
            </div>
          </div>
        </>
      )}

      {vybiraemMessendzher && (
        /*
          ⛔ ЛИСТ ПОДПИСАН «ОТВЕТИТЬ ЧЕРЕЗ», А НЕ «НАПИСАТЬ СЮДА» (макет
          владельца, `s615`, экран 4). Прежнее слово осталось у КНОПКИ,
          открывающей лист: она про ход, лист — про выбор канала ответа.
        */
        <Shtorka
          zagolovok={text("obrashcheniya.otvetit_cherez")}
          onZakryt={() => setVybiraemMessendzher(false)}
        >
          {/*
            ⛔ В ЛИСТЕ СТОЯТ ВСЕ КАНАЛЫ, А ТЕКУЩИЙ — С ГАЛОЧКОЙ (макет, экран 4).
            Раньше список показывал только ОСТАЛЬНЫЕ: человек открывал его и не
            видел, откуда сейчас уйдёт ответ, — то есть главную величину экрана
            приходилось держать в голове. Текущий не нажимается: идти некуда,
            он и так здесь.
          */}
          {vseMessendzhery.map((m) => (
            <button
              key={`${m.kind}-${m.adres}`}
              type="button"
              data-testid="vybor-linii"
              data-channel={m.channel_id}
              disabled={idyot || arenda.tolkoProsmotr || m.eto_tekushchiy}
              onClick={() => {
                if (m.eto_tekushchiy) return;

                setVybiraemMessendzher(false);
                // ⛔ Открываем ИМЕННО тот номер, который назван в строке
                // (`s614`): иначе подпись «WhatsApp · +7 (925)…» вела бы в
                // соседний номер клиники.
                void vypolnit(() =>
                  drugoyMessendzher(dannye.id, m.kind, m.channel_id),
                ).then((svezhiy) => {
                  // Сервер вернул СОСЕДНЕЕ обращение — его и открываем.
                  if (svezhiy !== null && svezhiy.id !== dannye.id)
                    onOtkryt?.(svezhiy.id);
                });
              }}
              className={cn(
                "flex w-full items-center gap-2.5 rounded-ops-md px-3 py-3 text-left text-ops-body text-ops-text",
                m.eto_tekushchiy
                  ? "disabled:opacity-100"
                  : "hover:bg-ops-surface-2 disabled:opacity-40",
              )}
            >
              <span className="shrink-0">
                <ZnachokKanala
                  kind={m.kind}
                  color={dannye.shapka.filial.color}
                  razmer={22}
                />
              </span>

              {/*
                ⛔ НОМЕР ВТОРОЙ СТРОКОЙ, А НЕ ХВОСТОМ К ИМЕНИ (макет, экран 4).
                У клиники два номера WhatsApp, и в пилюлю ряда сервер дописывает
                номер прямо в подпись вида (`s614`) — иначе две немые «WhatsApp»
                не отличить. В лист на 390 эта склейка не влезает, и сервер
                отдаёт сюда две РАЗНЫЕ величины: имя мессенджера и нашу подпись.
              */}
              <span className="min-w-0 flex-1">
                <span className="block truncate font-semibold">
                  {m.nazvanie}
                </span>
                {m.podpis !== "" && (
                  <span className="mt-0.5 block truncate text-ops-caption text-ops-text-secondary">
                    {m.podpis}
                    {/* `s720`: чья линия — сети или филиала; у сети есть и линии филиалов, путать их нельзя. */}
                    {m.filial != null && m.filial !== "" && <span data-testid="liniya-chya"> · {m.filial}</span>}
                  </span>
                )}
                {/* `s720`: беседы на линии ещё нет — её откроет выбор; сказано до нажатия. */}
                {m.est_perepiska === false && (
                  <span className="mt-0.5 block text-ops-caption text-ops-text-tertiary" data-testid="liniya-bez-perepiski">
                    {text("obrashcheniya.kuda.perepiski_net")}
                  </span>
                )}
              </span>

              {m.eto_tekushchiy && (
                <span className="flex h-[18px] w-[18px] shrink-0 items-center justify-center rounded-full bg-ops-primary text-ops-on-primary">
                  <IconCheck size={12} stroke={3} />
                </span>
              )}
            </button>
          ))}
        </Shtorka>
      )}

      {vybiraemShablon && (
        <VyborShablona
          obrashchenieId={dannye.id}
          zanyat={idyot || arenda.tolkoProsmotr}
          onPodstavit={(t) => {
            setChernovik(t);
            setVybiraemShablon(false);
          }}
          onOtpravit={(id) => {
            setVybiraemShablon(false);
            void odnoNazhatie(`shablon|${String(id)}`, (klyuch) => poslatShablon(dannye.id, String(id), klyuch));
          }}
          onZakryt={() => setVybiraemShablon(false)}
          onDrugayaLiniya={(channelId) => {
            setVybiraemShablon(false);
            void vypolnit(() => drugoyMessendzher(dannye.id, "whatsapp", channelId)).then((svezhiy) => {
              if (svezhiy !== null && svezhiy.id !== dannye.id) onOtkryt?.(svezhiy.id);
            });
          }}
        />
      )}

      {vybiraemPrichinu && (
        <VyborPrichiny
          prichiny={dannye.prichiny_otkaza}
          onZakryt={() => setVybiraemPrichinu(false)}
          onVybor={async (code) => {
            setVybiraemPrichinu(false);
            await vypolnit(() => otbrosit(dannye.id, code));
          }}
        />
      )}

      {otkladyvaem && (
        <Otlozhit
          prichiny={dannye.prichiny_otkladyvaniya}
          zanyat={idyot}
          onZakryt={() => setOtkladyvaem(false)}
          onOtlozhit={async (prichina, doKogda, zametka) => {
            setOtkladyvaem(false);
            await vypolnit(() =>
              otlozhit(dannye.id, prichina, doKogda, zametka),
            );
          }}
        />
      )}

      {pochemuNeVyshlo !== null && (
        <Shtorka
          zagolovok={text("obrashcheniya.nadiktovat")}
          onZakryt={() => setPochemuNeVyshlo(null)}
        >
          <p className="text-ops-body text-ops-text">
            {/*
              ⛔ Сервер отвечает СЛОВАМИ, и они показываются как есть. Свои
              коды («mikrofon_ne_dali», «zapis_ne_vyshla») переводятся словарём;
              всё прочее пришло от сервера уже по-людски.
            */}
            {pochemuNeVyshlo === "mikrofon_ne_dali" ||
            pochemuNeVyshlo === "zapis_ne_vyshla" ||
            pochemuNeVyshlo === "rasshifrovka_ne_vyshla"
              ? text(`obrashcheniya.${pochemuNeVyshlo}`)
              : pochemuNeVyshlo}
          </p>
        </Shtorka>
      )}

      {ishchemKlientku && (
        <PoiskKlientki
          onZakryt={() => setIshchemKlientku(false)}
          onVybor={async (id) => {
            setIshchemKlientku(false);
            await vypolnit(() => etoKlientka(dannye.id, id));
          }}
        />
      )}

      {vybiraemDlyaObedineniya && (
        <PoiskKlientki
          onZakryt={() => setVybiraemDlyaObedineniya(false)}
          onVybor={(id) => {
            setVybiraemDlyaObedineniya(false);
            setPodtverzhdaemObedinenie({ id });
          }}
        />
      )}

      {podtverzhdaemObedinenie !== null && (
        <Shtorka
          zagolovok={text("obrashcheniya.obedinit_zagolovok")}
          onZakryt={() => setPodtverzhdaemObedinenie(null)}
        >
          <p className="text-ops-caption text-ops-text">
            {text("obrashcheniya.obedinit_vopros")}
          </p>
          <div className="mt-3 flex flex-wrap gap-1.5">
            <button
              type="button"
              disabled={idyot}
              onClick={() => {
                const id = podtverzhdaemObedinenie.id;
                setPodtverzhdaemObedinenie(null);
                void vypolnit(() => obedinit(dannye.id, id));
              }}
              className="shrink-0 rounded-ops-pill bg-ops-primary px-3 py-1.5 text-ops-caption text-ops-on-primary disabled:opacity-40"
            >
              {text("obrashcheniya.podtverdit")}
            </button>
            <button
              type="button"
              onClick={() => setPodtverzhdaemObedinenie(null)}
              className="shrink-0 rounded-ops-pill border border-ops-border bg-ops-surface px-3 py-1.5 text-ops-caption text-ops-text-secondary"
            >
              {text("obrashcheniya.peredumal")}
            </button>
          </div>
        </Shtorka>
      )}

      {razedinyaem && (
        <Shtorka
          zagolovok={text("obrashcheniya.razedinit_zagolovok")}
          onZakryt={() => setRazhedinyaem(false)}
        >
          {dannye.svyazannye.length === 0 ? (
            <p className="py-4 text-center text-ops-caption text-ops-text-tertiary">
              {text("obrashcheniya.razedinit_net")}
            </p>
          ) : (
            <div className="space-y-1">
              {dannye.svyazannye.map((k) => (
                <div
                  key={k.id}
                  className="flex items-center justify-between gap-2 rounded-ops-md border border-ops-border px-3 py-2"
                >
                  <span className="truncate text-ops-caption text-ops-text">{k.imya}</span>
                  <button
                    type="button"
                    disabled={idyot}
                    onClick={() => {
                      setRazhedinyaem(false);
                      void vypolnit(() => razedinit(dannye.id, k.id));
                    }}
                    className="shrink-0 rounded-ops-pill border border-ops-border px-3 py-1 text-ops-caption text-ops-text hover:border-ops-danger hover:text-ops-danger disabled:opacity-40"
                  >
                    {text("obrashcheniya.razedinit")}
                  </button>
                </div>
              ))}
            </div>
          )}
        </Shtorka>
      )}
    </div>
  );
}

/**
 * ⛔ ПОДТВЕРЖДЕНИЕ ГОВОРИТ, ЧТО БУДЕТ, А НЕ «ВЫ УВЕРЕНЫ?» (владелец, п.10).
 *
 * «Вы уверены?» не отвечает ни на один вопрос дежурного и потому пролистывается
 * не читая. Вопрос называет ИСХОД — «Закрыть обращение, исход „записана"?» — и
 * кнопка согласия несёт то же слово, что вопрос: «Да, закрыть».
 */
function Podtverzhdenie({
  vopros,
  da,
  otmena,
  zanyat,
  onDa,
  onOtmena,
}: {
  vopros: string;
  da: string;
  otmena: string;
  zanyat: boolean;
  onDa: () => void;
  onOtmena: () => void;
}) {
  /*
   * ⛔ ОДИН ПОРЯДОК КНОПОК НА ВСЕХ ШИРИНАХ (`s605`, поймано на макетах Астры
   * 16.09; владелец: «не понял» — и был прав, объяснять это словами незачем).
   *
   * В макете подтверждение на компьютере шло «Нет, остаться» слева и «Да,
   * закрыть» справа, а на телефоне — «Да, закрыть» сверху. Один и тот же
   * поступок в двух разных местах: рука привыкает к одному экрану и на другом
   * жмёт не туда. Цена ошибки здесь — закрытое обращение, которое человек
   * закрывать не собирался.
   *
   * Согласие идёт ПЕРВЫМ везде. Отказ рядом и тише — он и так безопасен.
   */
  return (
    <div className="border-t border-ops-border bg-ops-surface-muted px-3 py-2.5">
      <p className="text-ops-caption text-ops-text">{vopros}</p>
      <div className="mt-2 flex flex-wrap gap-1.5">
        <button
          type="button"
          onClick={onDa}
          disabled={zanyat}
          className="shrink-0 rounded-ops-pill bg-ops-primary px-3 py-1 text-ops-caption text-ops-on-primary disabled:opacity-40"
        >
          {da}
        </button>
        <button
          type="button"
          onClick={onOtmena}
          className="shrink-0 rounded-ops-pill border border-ops-border bg-ops-surface px-3 py-1 text-ops-caption text-ops-text-secondary"
        >
          {otmena}
        </button>
      </div>
    </div>
  );
}

/**
 * Строка меню ходов: значок, слово, и два особых вида.
 *
 * ⛔ ОПАСНЫЙ ХОД ВЫГЛЯДИТ ИНАЧЕ (макет Астры). «Отбросить» — отказ от работы с
 * человеком, а не разбор; стоять рядом с «Записала на визит» и выглядеть так же
 * он не должен. Красным и последним.
 *
 * ⛔ ВЫКЛЮЧЕННЫЙ ХОД ОСТАЁТСЯ ВИДЕН. Спрятать «Шаблон» там, где он ещё не
 * наполнен, значило бы обещать меньше, чем описано владельцу: он знает, что
 * шаблоны будут, и искал бы кнопку.
 */
function HodStrokoy({
  znachok,
  slovo,
  onClick,
  opasnyy,
  vyklyuchen,
}: {
  znachok: React.ReactNode;
  slovo: string;
  onClick: () => void;
  opasnyy?: boolean;
  vyklyuchen?: boolean;
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={vyklyuchen}
      className={cn(
        "flex w-full items-center gap-2.5 px-3 py-2.5 text-left text-ops-caption hover:bg-ops-surface-2 disabled:opacity-40 disabled:hover:bg-transparent",
        opasnyy ? "text-ops-danger" : "text-ops-text",
      )}
    >
      <span className="shrink-0">{znachok}</span>
      {slovo}
    </button>
  );
}

/**
 * ⛔⛔ ЛЕНТА ПУЗЫРЕЙ ВЫВЕДЕНА НАРУЖУ (`s341`, ПР-47). Её рисует теперь не только
 * экран обращений, но и блок переписки в КАРТОЧКЕ ЗАПИСИ — слово владельца
 * 22.09: «не реализованы сообщения!!!».
 *
 * ⛔ ЭКСПОРТ, А НЕ КОПИЯ, И ЭТО РЕШЕНИЕ. Перепиши пузыри во втором месте — и
 * правка «как показать сообщение» разъехалась бы на два ответа: разделитель
 * дня, пометка рассылки, галочка доставки, голосовое. Всё это уже решено
 * здесь, и решено один раз.
 *
 * ⛔ СЛОВА ДОЕЗЖАЮТ САМИ: `useText` читает наливку ЭКРАНА, а карточка записи
 * получает ту же область `screen.text` целиком — все 133 слова обращений в
 * ней есть. Проверено, а не предположено.
 */
export function Puzyri({
  lenta,
  onRasshifrovat,
  zanyat,
}: {
  lenta: SoobshchenieLenty[];
  onRasshifrovat: (stroka: number) => void;
  zanyat: boolean;
}) {
  const text = useText();

  return (
    <div className="flex flex-col">
      {lenta.map((m, i) => {
        // Разделитель ставится там, где день СМЕНИЛСЯ по сравнению с прошлым
        // пузырём. Считаем по соседу в списке, а не бегущей переменной: список
        // перерисовывается опросом каждые пять секунд, и переменная, пережившая
        // отрисовку, начала бы врать при первом же частичном обновлении.
        const novayaData = i === 0 || m.data !== lenta[i - 1].data;
        const predydushchaya = i === 0 ? null : lenta[i - 1];
        const podpisVidna = m.podpis != null && (novayaData || predydushchaya === null || Boolean(predydushchaya.sobytie) || klyuchPodpisi(predydushchaya) !== klyuchPodpisi(m));

        /* ⛔ `s677`: запись из переписки — строкой посреди ленты, не пузырём:
           это событие, а не чьи-то слова. */
        if (m.sobytie) {
          return (
            <div key={m.id} className="flex flex-col">
              {novayaData && (
                <span className="my-2 self-center rounded-ops-pill border border-ops-border bg-ops-surface px-2.5 py-0.5 text-ops-micro text-ops-text-secondary">
                  {podpisDaty(m.data, text)}
                </span>
              )}
              <span
                className="my-1.5 inline-flex max-w-[92%] items-center gap-1.5 self-center rounded-ops-pill bg-[#e3f5ea] px-3 py-1 text-ops-sm font-medium text-[#1f6b41]"
                data-testid={m.sobytie === "oplata" ? "stroka-oplaty" : "stroka-zapisi"}
              >
                {/* `s705`: подтверждённая оплата — такой же строкой-событием, со своим значком. */}
                {m.sobytie === "oplata" ? <IconCash size={16} /> : <IconCalendarCheck size={16} />}
                {m.tekst}
                <span className="font-normal text-[#3a7d55]">· {m.vremya}</span>
              </span>
            </div>
          );
        }

        return (
          <div key={m.id} className="flex flex-col">
            {novayaData && (
              <span className="my-2 self-center rounded-ops-pill border border-ops-border bg-ops-surface px-2.5 py-0.5 text-ops-micro text-ops-text-secondary">
                {podpisDaty(m.data, text)}
              </span>
            )}
            {/*
              `s713`: подпись и пузырь — общие с лентой клиентки (`Puzyr`). Подпись стоит
              там, где сменился автор или линия, а не над каждой строкой.
            */}
            {podpisVidna && <PodpisStroki podpis={m.podpis} nashe={m.nashe} />}
            <Puzyr s={m} onRasshifrovat={() => onRasshifrovat(m.id)} zanyat={zanyat} posleSvoeyPodpisi={podpisVidna} />
          </div>
        );
      })}
    </div>
  );
}

function podpisDaty(
  iso: string,
  text: (k: string, v?: Record<string, string | number>) => string,
): string {
  const segodnya = new Date();
  const vchera = new Date(segodnya.getTime() - 86_400_000);
  const den = (d: Date) =>
    `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;

  if (iso === den(segodnya)) return text("obrashcheniya.segodnya");
  if (iso === den(vchera)) return text("obrashcheniya.vchera");

  const [g, m, d] = iso.split("-");
  return `${d}.${m}.${g}`;
}

/** Локальное время в вид, который понимает поле `datetime-local`. */
// `s731`: поле времени — московские часы на любом компьютере (см. `lib/vremyaMsk`).
const dlyaPolya = mskDlyaPolya;

/**
 * Лист «Отложить» — третий вид «ждёт» (`s605`, п.6 владельца).
 *
 * ⛔ ПРИЧИНА — СПИСКОМ, СЛОВА НЕОБЯЗАТЕЛЬНЫ, И ЭТО ПРАВИЛО ВЛАДЕЛЬЦА КО ВСЕЙ
 * СИСТЕМЕ (op-rules §31.9): «ну не будет админ писать каждый раз чтото руками
 * ты угораешь?». Кнопка живая при ВЫБРАННОЙ причине; поле слов дописывает
 * подробность, но ничего не требует.
 *
 * ⛔ ЧАС ВОЗВРАТА — ГОТОВЫМИ КНОПКАМИ, а не только полем даты. Дежурный
 * откладывает на ходу, между разговорами; заставлять его набирать дату и
 * время значит получить отложенное «на когда-нибудь» или не получить вовсе.
 * Точное время остаётся рядом — для тех случаев, когда час известен.
 */
function Otlozhit({
  prichiny,
  zanyat,
  onOtlozhit,
  onZakryt,
}: {
  prichiny: { code: string; label: string }[];
  zanyat: boolean;
  onOtlozhit: (prichina: string, doKogda: string, zametka?: string) => void;
  onZakryt: () => void;
}) {
  const text = useText();
  const label = useLabel();
  const [prichina, setPrichina] = useState<string | null>(null);
  const [zametka, setZametka] = useState("");
  const [tochno, setTochno] = useState("");
  /*
   * ⛔ НИЖНЯЯ ГРАНИЦА ПОЛЯ ВРЕМЕНИ БЕРЁТСЯ ОДИН РАЗ, ПРИ ОТКРЫТИИ ЛИСТА.
   * Поймал eslint: `Date.now()` прямо в разметке — нечистый вызов в рендере,
   * и граница дёргалась бы при каждой перерисовке. Лист живёт секунды, минута
   * запаса за это время не истечёт; а проверку «только в будущее» всё равно
   * держит сервер, а не поле.
   */
  const [nizhnyayaGranica] = useState(() =>
    dlyaPolya(new Date(Date.now() + 60_000)),
  );

  const cherezChas = () => new Date(Date.now() + 3_600_000);

  // 19:00 и 10:00 — по Москве, а не по часам компьютера (`s731`).
  const segodnyaVecherom = () => {
    const d = mskVChas(new Date(), 0, 19);

    return d.getTime() > Date.now() ? d : new Date(Date.now() + 3_600_000);
  };

  const zavtraUtrom = () => mskVChas(new Date(), 1, 10);

  const otlozhitNa = (kogda: Date) => {
    if (prichina === null) return;

    onOtlozhit(prichina, kogda.toISOString(), zametka);
  };

  return (
    <Shtorka
      zagolovok={text("obrashcheniya.otlozhit_zagolovok")}
      onZakryt={onZakryt}
    >
      <p className="mb-2 text-ops-caption text-ops-text-secondary">
        {label("obr_otlozhit_prichina")}
      </p>
      <div className="flex flex-wrap gap-1.5">
        {prichiny.map((p) => (
          <button
            key={p.code}
            type="button"
            onClick={() => setPrichina(p.code)}
            className={cn(
              "rounded-ops-pill border px-3 py-1.5 text-ops-caption",
              prichina === p.code
                ? "border-ops-primary bg-ops-primary text-ops-on-primary"
                : "border-ops-border text-ops-text hover:border-ops-primary hover:text-ops-primary",
            )}
          >
            {p.label}
          </button>
        ))}
      </div>

      <input
        type="text"
        value={zametka}
        onChange={(e) => setZametka(e.target.value)}
        placeholder={label("obr_otlozhit_zametka")}
        maxLength={190}
        className="mt-3 w-full rounded-ops-md border border-ops-border bg-ops-surface px-3 py-2 text-ops-body text-ops-text outline-none focus:border-ops-primary"
      />

      <p className="mb-2 mt-4 text-ops-caption text-ops-text-secondary">
        {label("obr_otlozhit_do")}
      </p>
      <div className="flex flex-wrap gap-1.5">
        {(
          [
            [text("obrashcheniya.otlozhit_cherez_chas"), cherezChas],
            [
              text("obrashcheniya.otlozhit_segodnya_vecherom"),
              segodnyaVecherom,
            ],
            [text("obrashcheniya.otlozhit_zavtra_utrom"), zavtraUtrom],
          ] as const
        ).map(([slovo, kogda]) => (
          <button
            key={slovo}
            type="button"
            disabled={prichina === null || zanyat}
            onClick={() => otlozhitNa(kogda())}
            className="rounded-ops-pill border border-ops-border px-3 py-1.5 text-ops-caption text-ops-text hover:border-ops-primary hover:text-ops-primary disabled:opacity-40"
          >
            {slovo}
          </button>
        ))}
      </div>

      <div className="mt-3 flex items-center gap-2">
        <input
          type="datetime-local"
          value={tochno}
          min={nizhnyayaGranica}
          onChange={(e) => setTochno(e.target.value)}
          className="min-w-0 flex-1 rounded-ops-md border border-ops-border bg-ops-surface px-3 py-2 text-ops-body text-ops-text outline-none focus:border-ops-primary"
        />
        <button
          type="button"
          disabled={prichina === null || tochno === "" || zanyat}
          onClick={() => { const m = mskIzPolya(tochno); if (m !== null) otlozhitNa(m); }}
          className="shrink-0 rounded-ops-pill bg-ops-primary px-3 py-2 text-ops-caption text-ops-on-primary disabled:opacity-40"
        >
          {text("obrashcheniya.otlozhit")}
        </button>
      </div>
    </Shtorka>
  );
}

function VyborPrichiny({
  prichiny,
  onVybor,
  onZakryt,
}: {
  prichiny: { code: string; label: string }[];
  onVybor: (code: string) => void;
  onZakryt: () => void;
}) {
  const text = useText();

  return (
    <Shtorka
      zagolovok={text("obrashcheniya.vybrat_prichinu")}
      onZakryt={onZakryt}
    >
      <div className="flex flex-wrap gap-1.5">
        {prichiny.map((p) => (
          <button
            key={p.code}
            type="button"
            onClick={() => onVybor(p.code)}
            className="rounded-ops-pill border border-ops-border px-3 py-1.5 text-ops-caption text-ops-text hover:border-ops-primary hover:text-ops-primary"
          >
            {p.label}
          </button>
        ))}
      </div>
    </Shtorka>
  );
}

export function PoiskKlientki({
  onVybor,
  onZakryt,
}: {
  onVybor: (id: number) => void;
  onZakryt: () => void;
}) {
  const text = useText();
  const label = useLabel();
  const [q, setQ] = useState("");
  // Поле живёт без задержки, сервер спрашивается отложенно — иначе каждый символ
  // гонял бы запрос. Ответ держит кэш запроса, а не своё состояние: своё
  // пришлось бы двигать из эффекта, а это каскад отрисовок.
  const otlozhennyy = useZaderzhka(q.trim());
  const najdennye = useQuery({
    queryKey: ["obrashcheniya", "poisk-klientki", otlozhennyy],
    queryFn: () => poiskKlientki(otlozhennyy),
    enabled: otlozhennyy.length >= 2,
    retry: false,
  });
  const stroki: NaydennayaKlientka[] | null = najdennye.data?.stroki ?? null;

  return (
    <Shtorka zagolovok={text("obrashcheniya.eto_klientka")} onZakryt={onZakryt}>
      <input
        autoFocus
        value={q}
        onChange={(e) => setQ(e.target.value)}
        placeholder={label("obr_poisk")}
        className="w-full rounded-ops-pill border border-ops-border px-4 py-2 text-ops-body outline-none focus:border-ops-primary"
      />
      <div className="mt-2 max-h-64 overflow-y-auto">
        {stroki !== null && stroki.length === 0 && (
          <p className="py-4 text-center text-ops-caption text-ops-text-tertiary">
            {text("obrashcheniya.nichego_ne_nashlos")}
          </p>
        )}
        {stroki?.map((k) => (
          <button
            key={k.id}
            type="button"
            onClick={() => onVybor(k.id)}
            className="flex w-full items-baseline justify-between gap-2 border-b border-ops-border px-1 py-2 text-left last:border-b-0 hover:bg-ops-surface-2"
          >
            <span className="truncate text-ops-caption text-ops-text">
              {k.customer_display}
            </span>
            <span className="shrink-0 text-ops-micro text-ops-text-tertiary">
              {k.telefon ?? ""} {k.posledniy_vizit ?? ""}
            </span>
          </button>
        ))}
      </div>
    </Shtorka>
  );
}

/** Нижняя шторка — на телефоне она привычнее модального окна посреди экрана. */
export function Shtorka({
  zagolovok,
  onZakryt,
  children,
}: {
  zagolovok: string;
  onZakryt: () => void;
  children: React.ReactNode;
}) {
  return (
    <div className="fixed inset-0 z-50 flex items-end justify-center bg-black/30 sm:items-center">
      <div className="max-h-[80vh] w-full overflow-y-auto rounded-t-ops-card bg-ops-surface p-4 sm:max-w-md sm:rounded-ops-card">
        <div className="mb-3 flex items-center justify-between">
          <span className="text-ops-label font-medium text-ops-text">
            {zagolovok}
          </span>
          {/*
            ⛔ ЗНАЧКОМ, А НЕ СИМВОЛОМ ШРИФТА (`s605`, п.9: «какие то черные
            квадратаы появляются»). `✕` (U+2715) и `ⓘ` (U+24D8) есть не во
            всяком системном шрифте телефона: где их нет, браузер рисует
            «тофу» — чёрный прямоугольник. Значки набора приезжают своим SVG и
            от чужого шрифта не зависят.
          */}
          <button
            type="button"
            onClick={onZakryt}
            aria-label={zagolovok}
            className="text-ops-text-tertiary hover:text-ops-text"
          >
            <IconX size={18} />
          </button>
        </div>
        {children}
      </div>
    </div>
  );
}

/**
 * ЛИСТ ВЫБОРА ШАБЛОНА — ДВА РАЗДЕЛА, И ЭТО НЕ УКРАШЕНИЕ (`s606`, Ф3).
 *
 * ⛔⛔ ПО НАЖАТИЮ ПРОИСХОДИТ РАЗНОЕ, ПОЭТОМУ И РАЗДЕЛА ДВА.
 *
 * Согласованный шаблон УХОДИТ КЛИЕНТКЕ СРАЗУ и дословно: править его нельзя,
 * он утверждён Meta, стоит денег и работает даже когда сутки с последнего слова
 * клиентки прошли. Наша заготовка ПОДСТАВЛЯЕТСЯ В ПОЛЕ: её читают, правят и
 * отправляют обычным ответом, и она требует открытого окна.
 *
 * Свалить их в один список значило бы, что дежурный нажимает, не зная, что
 * сейчас случится, — ровно то, на что владелец жаловался пунктом 10: «шаблоны
 * действий над чатом не понятны — что для чего и что будет». Поэтому у каждой
 * строки стоит СВОЁ слово действия, а не общее «выбрать».
 */
function VyborShablona({
  obrashchenieId,
  zanyat,
  onPodstavit,
  onOtpravit,
  onZakryt,
  onDrugayaLiniya,
}: {
  obrashchenieId: number;
  zanyat: boolean;
  onPodstavit: (tekst: string) => void;
  onOtpravit: (id: string | number) => void;
  onZakryt: () => void;
  /** `s720`: перейти на другую нашу линию, где согласованные шаблоны есть. */
  onDrugayaLiniya: (channelId: number) => void;
}) {
  const text = useText();
  const spisok = useQuery({
    queryKey: ["obrashcheniya", "shablony", obrashchenieId],
    queryFn: () => shablony(obrashchenieId),
    retry: false,
  });

  const soglasovannye = spisok.data?.soglasovannye ?? [];
  const zagotovki = spisok.data?.zagotovki ?? [];
  /*
    ⛔⛔ СНАЧАЛА ВИДНО ЦЕЛИКОМ — ПОТОМ УХОДИТ (владелец, 24.09.2026: «надо
    иметь возможность сначала полностью увидеть шаблон потом слать»). В списке
    от шаблона видна обрезанная первая строка, а нажатие отправляло его
    клиентке сразу: дежурный слал текст, которого не читал.
  */
  const [prosmotr, setProsmotr] = useState<ShablonStroka | null>(null);
  /*
    ⛔⛔ `s705` ССЫЛКА ЮKassa ГОТОВИТСЯ САМА (владелец, 05.10.2026: «при подготовке сообщения
    система АВТОМАТИЧЕСКИ получает или создаёт ссылку … отдельное предварительное нажатие
    „Выслать ссылку оплаты“ не должно требоваться»). Открыли предпросмотр шаблона, которому нужна
    ссылка, — сервер отдаёт действующую или выпускает новую, и в тексте стоит она, а не {{2}}.
    Касса не ответила — причина словами и «Повторить»; неполный шаблон не отправляется.
  */
  const [gotovitsya, setGotovitsya] = useState(false);
  const podgotovit = async (s: ShablonStroka) => {
    setGotovitsya(true);
    try {
      setProsmotr(await podgotovitShablon(obrashchenieId, String(s.id)));
    } catch (e) {
      const slovo = (e as { response?: { data?: { message?: unknown } } }).response?.data?.message;
      setProsmotr({ ...s, podgotovit: false, mozhno_povtorit: true, ne_hvataet: typeof slovo === 'string' && slovo !== '' ? slovo : text("obrashcheniya.shablon_ne_gotov") });
    } finally {
      setGotovitsya(false);
    }
  };
  /*
    ⛔⛔ `s720` ПРЕДПРОСМОТР СЧЁТ НЕ СОЗДАЁТ (приёмка 06.10.2026: «предпросмотр не должен создавать
    счёт; создание счёта — отдельное явное действие»). Это заменяет правило `s705` выше: открыть
    шаблон — только посмотреть. Нужна ссылка оплаты, а счёта по записи нет — предпросмотр говорит
    это словами и даёт кнопку «Создать счёт и подставить ссылку»; до неё «Отправить» выключена, и
    сервер такой шаблон без счёта не отправит.
  */
  const otkrytProsmotr = (s: ShablonStroka) => setProsmotr(s);
  const sostoyanie = spisok.data?.soglasovannye_sostoyanie ?? null;

  if (prosmotr !== null) {

    return (
      <Shtorka zagolovok={text("obrashcheniya.shablon_zagolovok")} onZakryt={onZakryt}>
        <div className="space-y-3">
          {prosmotr.naznachenie !== undefined && (
            <p className="text-ops-caption text-ops-text-secondary">
              {prosmotr.naznachenie}
            </p>
          )}
          <div className="rounded-ops-lg bg-ops-puzyr-svoy px-3 py-2 text-ops-caption leading-snug text-ops-text">
            <TekstShablona tekst={prosmotr.tekst} />
          </div>
          {/* `s705`: шаблон с переменными — сервер сказал, чего не хватает; пустые скобки клиентке не уходят. */}
          {gotovitsya && (
            <p className="text-ops-caption text-ops-text-secondary" data-testid="shablon-gotovitsya">
              {text("obrashcheniya.shablon_gotovlyu")}
            </p>
          )}
          {!gotovitsya && prosmotr.ne_hvataet != null && (
            <p className="rounded-ops-md bg-ops-danger-soft px-3 py-2 text-ops-caption text-ops-danger" data-testid="shablon-ne-hvataet">
              {prosmotr.ne_hvataet}
            </p>
          )}
          {!gotovitsya && prosmotr.podgotovit === true && prosmotr.ne_hvataet == null && (
            <div className="space-y-2 rounded-ops-md bg-ops-info-soft px-3 py-2 text-ops-caption text-ops-info" data-testid="shablon-nuzhen-schyot">
              <p>{text("obrashcheniya.shablon_schyota_net")}</p>
              <button
                type="button"
                disabled={zanyat}
                onClick={() => void podgotovit(prosmotr)}
                className="rounded-ops-pill border border-current px-4 py-2 font-medium disabled:opacity-40"
                data-testid="shablon-sozdat-schyot"
              >
                {text("obrashcheniya.shablon_sozdat_schyot")}
              </button>
            </div>
          )}
          {!gotovitsya && prosmotr.mozhno_povtorit === true && (
            <button
              type="button"
              onClick={() => void podgotovit(prosmotr)}
              className="rounded-ops-pill border border-ops-border px-4 py-2 text-ops-caption text-ops-text hover:bg-ops-surface-2"
              data-testid="shablon-povtorit"
            >
              {text("obrashcheniya.shablon_povtorit")}
            </button>
          )}
          <div className="flex gap-2">
            <button
              type="button"
              onClick={() => setProsmotr(null)}
              className="flex-1 rounded-ops-pill border border-ops-border px-4 py-2.5 text-ops-body text-ops-text hover:bg-ops-surface-2"
            >
              {text("obrashcheniya.nazad")}
            </button>
            <button
              type="button"
              disabled={zanyat || gotovitsya || prosmotr.podgotovit === true || prosmotr.ne_hvataet != null}
              onClick={() => onOtpravit(prosmotr.id)}
              className="flex-1 rounded-ops-pill bg-ops-primary px-4 py-2.5 text-ops-body font-medium text-ops-on-primary disabled:opacity-40"
            >
              {text("obrashcheniya.shablon_otpravit_klientke")}
            </button>
          </div>
        </div>
      </Shtorka>
    );
  }

  return (
    <Shtorka zagolovok={text("obrashcheniya.shablon_zagolovok")} onZakryt={onZakryt}>
      <div className="space-y-4">
        <RazdelShablonov
          zagolovok={text("obrashcheniya.shablon_zagotovki")}
          pusto={text("obrashcheniya.shablon_net")}
          stroki={zagotovki}
          slovoDeystviya={text("obrashcheniya.shablon_podstavit")}
          zanyat={zanyat}
          onVybor={(s) => onPodstavit(s.tekst)}
        />
        <RazdelShablonov
          zagolovok={text("obrashcheniya.shablon_soglasovannye")}
          // `s720`: пустой список называет причину по ФАКТИЧЕСКОЙ линии (её слово собрал сервер).
          pusto={sostoyanie?.slovo ?? text("obrashcheniya.shablon_soglasovannyh_net")}
          stroki={soglasovannye}
          slovoDeystviya={text("obrashcheniya.shablon_posmotret")}
          zanyat={zanyat}
          onVybor={(s) => otkrytProsmotr(s)}
        />
        {/*
          `s720` (приёмка 06.10.2026: «маршрут пользователю неясен»). Согласованные шаблоны
          принадлежат номеру официального WhatsApp. У этой линии их нет — экран называет линии,
          где они есть, с числом шаблонов; переход открывает переписку с той же клиенткой там.
        */}
        {soglasovannye.length === 0 && (sostoyanie?.drugie_linii.length ?? 0) > 0 && (
          <div data-testid="shablony-drugie-linii">
            <p className="mb-1.5 text-ops-caption text-ops-text-secondary">
              {text("obrashcheniya.shablony_drugie_linii")}
            </p>
            <div className="space-y-1">
              {sostoyanie!.drugie_linii.map((l) => (
                <button
                  key={l.channel_id}
                  type="button"
                  disabled={zanyat}
                  onClick={() => onDrugayaLiniya(l.channel_id)}
                  className="flex w-full items-baseline justify-between gap-2 rounded-ops-md border border-ops-border px-3 py-2 text-left hover:border-ops-primary disabled:opacity-40"
                  data-testid="shablony-pereyti"
                >
                  <span className="min-w-0">
                    <span className="block truncate text-ops-caption text-ops-text">{l.podpis}</span>
                    <span className="block text-ops-caption text-ops-text-tertiary">
                      {text("obrashcheniya.shablonov", { n: l.shablonov })}
                    </span>
                  </span>
                  <span className="shrink-0 text-ops-caption text-ops-primary">{text("obrashcheniya.shablony_pereyti")}</span>
                </button>
              ))}
            </div>
          </div>
        )}
      </div>
    </Shtorka>
  );
}

function RazdelShablonov({
  zagolovok,
  pusto,
  stroki,
  slovoDeystviya,
  zanyat,
  onVybor,
}: {
  zagolovok: string;
  pusto: string;
  stroki: ShablonStroka[];
  slovoDeystviya: string;
  zanyat: boolean;
  onVybor: (s: ShablonStroka) => void;
}) {
  return (
    <div>
      <p className="mb-1.5 text-ops-caption font-medium text-ops-text-secondary">
        {zagolovok}
      </p>
      {stroki.length === 0 ? (
        /* Пустой раздел говорит СВОИМ словом: пустота читалась бы как поломка. */
        <p className="py-2 text-ops-caption text-ops-text-secondary" data-testid="razdel-pusto">{pusto}</p>
      ) : (
        <div className="space-y-1">
          {stroki.map((s) => (
            <button
              key={String(s.id)}
              type="button"
              disabled={zanyat}
              onClick={() => onVybor(s)}
              className="flex w-full flex-col gap-0.5 rounded-ops-md border border-ops-border px-3 py-2 text-left hover:border-ops-primary disabled:opacity-40"
            >
              <span className="flex items-baseline justify-between gap-2">
                <span className="truncate text-ops-caption text-ops-text">
                  {s.nazvanie}
                </span>
                {/* Слово действия — у КАЖДОЙ строки: оно и есть ответ на «что будет». */}
                <span className="shrink-0 text-ops-micro text-ops-primary">
                  {slovoDeystviya}
                </span>
              </span>
              {s.naznachenie !== undefined && (
                <span className="text-ops-micro text-ops-text-tertiary">
                  {s.naznachenie}
                </span>
              )}
              {/*
                `s713` по контракту `s711` (Д-03/10): заготовке не хватает данных (филиал, адрес) —
                сервер говорит, чего именно; незаполненное место останется в тексте скобками, и
                такой текст сервер клиентке не отправит.
              */}
              {s.ne_hvataet != null && s.ne_hvataet !== "" && (
                <span className="text-ops-caption text-ops-danger" data-testid="zagotovka-ne-hvataet">
                  {s.ne_hvataet}
                </span>
              )}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
